import React from 'react';

import * as fortAwesome from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ReactComponent as AppealsAndGrievancesIcon } from './AandG.svg';
import { ReactComponent as Add } from './add.svg';
import { ReactComponent as AdminIcon } from './Admin.svg';
import { ReactComponent as AppealsAndGrievancesTeal } from './AppealsAndGrievancesTeal.svg';
import { ReactComponent as AppealsAndGrievancesWhite } from './AppealsAndGrievancesWhite.svg';
import { ReactComponent as Attachment } from './attach.svg';
import { ReactComponent as AuditHistoryIcon } from './Audit-History.svg';
import { ReactComponent as AuthorizationsIcon } from './Authorizations.svg';
import { ReactComponent as AVASchedulerIcon } from './AVA-Scheduler.svg';
import blackCardIconSrc from './blackCard.png';
import { ReactComponent as BrokerPortalIcon } from './Broker-Portal.svg';
import { ReactComponent as Cancel } from './cancel.svg';
import { ReactComponent as CancelWhite } from './cancel_white.svg';
import { ReactComponent as CareOnDemandIcon } from './Care-on-demand.svg';
import { ReactComponent as CareManagementIcon } from './CareManagement.svg';
import { ReactComponent as FirstAidIcon } from './Census.svg';
import { ReactComponent as Check } from './check.svg';
import { ReactComponent as ClaimsAuditorIcon } from './Claim-auditor.svg';
import { ReactComponent as ClaimsInquiryIcon } from './Claims-Inquiry.svg';
import { ReactComponent as Coder360Icon } from './Coder360.svg';
import { ReactComponent as Copy } from './copy.svg';
import { ReactComponent as CopyWhite } from './copy_white.svg';
import { ReactComponent as HeadphoneIcon } from './CRM.svg';
import { ReactComponent as DashboardIcon } from './Dashboards.svg';
import { ReactComponent as Edit } from './edit.svg';
import { ReactComponent as EligibilityIcon } from './Elibility-and-Benefits.svg';
import { ReactComponent as EncountersIcon } from './Encounters-360.svg';
import { ReactComponent as FormBuilderIcon } from './FormBuilder.svg';
import { ReactComponent as Inbox } from './inbox.svg';
import { ReactComponent as InboxBlue } from './inbox_blue.svg';
import { ReactComponent as InternalEscalationIcon } from './InternalEscalation.svg';
import { ReactComponent as JSAIcon } from './JSA.svg';
import { ReactComponent as MemberIcon } from './Member360.svg';
import { ReactComponent as MemberPortalAdminIcon } from './MemberPortalAdmin.svg';
import { ReactComponent as MessagesIcon } from './Messages.svg';
import { ReactComponent as NewEmail } from './new-email.svg';
import { ReactComponent as PanelManagementIcon } from './Panel-Management.svg';
import { ReactComponent as SearchPatientIcon } from './Patient-360.svg';
import { ReactComponent as PatientPriorityIcon } from './Patient-Priority.svg';
import { ReactComponent as ProviderDataIcon } from './ProviderData.svg';
import { ReactComponent as Reception } from './reception.svg';
import { ReactComponent as Reply } from './reply.svg';
import { ReactComponent as ReportsSubmissionIcon } from './ReportsSubmission.svg';
import { ReactComponent as Send } from './send.svg';
import { ReactComponent as SendWhite } from './send_white.svg';
import { ReactComponent as SupplementalReviewIcon } from './SupplementalReview.svg';
import { ReactComponent as Trash } from './trash.svg';
import { ReactComponent as TrashWhite } from './trash_white.svg';
import { ReactComponent as Upload } from './upload.svg';
import { ReactComponent as UtilizationManagementIcon } from './Utilization-Management.svg';
import { ReactComponent as VirtualPCP } from './VirtualPCP.svg';
import { ReactComponent as Warning } from './warning.svg';

const ListPatientsIcon = (props) => (
    <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        width={props.width}
        height={props.height}
        viewBox='0 0 954.4 954.4'
    >
        <g>
            <g>
                <path
                    d='M406.301,70.8h309.3c13.5,0,24.5-11,24.5-24.5v-0.5c0-13.5-11-24.5-24.5-24.5h-309.3c-13.5,0-24.5,11-24.5,24.5v0.5
			C381.7,59.8,392.7,70.8,406.301,70.8z'
                />
                <path
                    d='M381.7,140.2c0,13.5,11,24.5,24.5,24.5h416c13.5,0,24.5-11,24.5-24.5v-0.5c0-13.5-11-24.5-24.5-24.5h-416
			c-13.5,0-24.5,11-24.5,24.5V140.2L381.7,140.2z'
                />
                <path
                    d='M381.7,234c0,13.5,11,24.5,24.5,24.5h416c13.5,0,24.5-11,24.5-24.5v-0.5c0-13.5-11-24.5-24.5-24.5h-416
			c-13.5,0-24.5,11-24.5,24.5V234L381.7,234z'
                />
                <path
                    d='M381.7,375.2c0,13.5,11,24.5,24.5,24.5h309.3c13.5,0,24.5-11,24.5-24.5v-0.5c0-13.5-11-24.5-24.5-24.5H406.301
			c-13.5,0-24.5,11-24.5,24.5L381.7,375.2L381.7,375.2z'
                />
                <path
                    d='M381.7,469.101c0,13.5,11,24.5,24.5,24.5h223.5c13.5,0,24.5-11,24.5-24.5v-0.5c0-13.5-11-24.5-24.5-24.5H406.301
			c-13.5,0-24.5,11-24.5,24.5L381.7,469.101L381.7,469.101z'
                />
                <path
                    d='M381.7,562.9c0,13.5,11,24.5,24.5,24.5h416c13.5,0,24.5-11,24.5-24.5v-0.5c0-13.5-11-24.5-24.5-24.5h-416
			c-13.5,0-24.5,11-24.5,24.5V562.9L381.7,562.9z'
                />
                <path
                    d='M381.7,723.5c0,13.2,10.7,23.8,23.8,23.8h403.9c13.2,0,23.8-10.699,23.8-23.8V723c0-13.2-10.7-23.8-23.8-23.8H405.5
			c-13.199,0-23.8,10.7-23.8,23.8V723.5L381.7,723.5z'
                />
                <path
                    d='M381.7,814.7c0,13.2,10.7,23.8,23.8,23.8h350.301c13.199,0,23.8-10.7,23.8-23.8v-0.5c0-13.2-10.7-23.8-23.8-23.8H405.5
			c-13.199,0-23.8,10.7-23.8,23.8V814.7L381.7,814.7z'
                />
                <path
                    d='M381.7,905.8c0,13.2,10.7,23.801,23.8,23.801h159.9c13.2,0,23.8-10.7,23.8-23.801v-0.5c0-13.199-10.7-23.8-23.8-23.8
			H405.5c-13.199,0-23.8,10.7-23.8,23.8V905.8L381.7,905.8z'
                />
                <path
                    d='M108,154.5v125.4h198.6V154.5c0-10.4-9.101-18.9-20.3-18.9H263.7c-4,0-7.7,1.8-10,4.8l-33.3,43.7l-8.1-15.8l12.9-25.3
			c1.8-3.5-0.9-7.5-5.1-7.5h-25.9c-4.1,0-6.8,4-5.1,7.5l12.9,25.3l-8,15.6l-32.2-43.4c-2.3-3.1-6.1-4.9-10.1-4.9H128
			C117.101,135.6,108,144,108,154.5z'
                />
                <path d='M207.3,121.6c33.5,0,60.8-27.3,60.8-60.8S240.8,0,207.3,0s-60.8,27.2-60.8,60.8C146.5,94.3,173.8,121.6,207.3,121.6z' />
                <path
                    d='M108,608.8h198.6V483.4c0-10.4-9.101-18.9-20.3-18.9H263.7c-4,0-7.7,1.8-10,4.8L220.4,513l-8.1-15.8l12.9-25.3
			c1.8-3.5-0.9-7.5-5.1-7.5h-25.9c-4.1,0-6.8,4-5.1,7.5l12.9,25.3l-8,15.6L161.8,469.4c-2.3-3.101-6.1-4.9-10.1-4.9H128
			c-11.2,0-20.3,8.5-20.3,18.9L108,608.8L108,608.8z'
                />
                <path d='M146.5,389.7c0,33.5,27.3,60.8,60.8,60.8s60.8-27.3,60.8-60.8s-27.3-60.8-60.8-60.8S146.5,356.1,146.5,389.7z' />
                <path
                    d='M306.601,829c0-10.399-9.101-18.899-20.3-18.899H263.7c-4,0-7.7,1.8-10,4.8l-33.3,43.7l-8.1-15.801l12.9-25.3
			c1.8-3.5-0.9-7.5-5.1-7.5h-25.9c-4.1,0-6.8,4-5.1,7.5l12.9,25.3l-8,15.601L161.8,815c-2.3-3.1-6.1-4.899-10.1-4.899H128
			c-11.2,0-20.3,8.5-20.3,18.899v125.4h198.601L306.601,829L306.601,829z'
                />
                <path d='M146.5,735.3c0,33.5,27.3,60.801,60.8,60.801s60.8-27.301,60.8-60.801s-27.3-60.8-60.8-60.8S146.5,701.7,146.5,735.3z' />
            </g>
        </g>
    </svg>
);

const HospitalIcon = () => (
    <svg
        viewBox='0 0 512 512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m271 60h-30v30.035156h-30.035156v30h30.035156v30.035156h30v-30.035156h30.035156v-30h-30.035156zm0 0' />
        <path d='m374.285156 90.035156v-90.035156h-236.570312v90.035156h-137.714844v421.964844h512v-421.964844zm-206.570312-60.035156h176.570312v150.070312h-176.570312zm107.714844 452h-38.859376v-71.769531h38.859376zm206.570312 0h-176.570312v-101.769531h-98.859376v101.769531h-176.570312v-361.964844h107.714844v90.035156h236.570312v-90.035156h107.714844zm0 0' />
        <path d='m68.855469 240.109375h30v40.03125h-30zm0 0' />
        <path d='m137.714844 240.109375h30v40.03125h-30zm0 0' />
        <path d='m206.570312 240.109375h30v40.03125h-30zm0 0' />
        <path d='m275.429688 240.109375h30v40.03125h-30zm0 0' />
        <path d='m344.285156 240.109375h30v40.03125h-30zm0 0' />
        <path d='m413.144531 240.109375h30v40.03125h-30zm0 0' />
        <path d='m68.855469 170.050781h30v40.035157h-30zm0 0' />
        <path d='m413.144531 170.050781h30v40.035157h-30zm0 0' />
        <path d='m68.855469 310.164062h30v40.03125h-30zm0 0' />
        <path d='m137.714844 310.164062h30v40.03125h-30zm0 0' />
        <path d='m206.570312 310.164062h30v40.03125h-30zm0 0' />
        <path d='m275.429688 310.164062h30v40.03125h-30zm0 0' />
        <path d='m344.285156 310.164062h30v40.03125h-30zm0 0' />
        <path d='m413.144531 310.164062h30v40.03125h-30zm0 0' />
        <path d='m68.855469 380.21875h30v40.035156h-30zm0 0' />
        <path d='m137.714844 380.21875h30v40.035156h-30zm0 0' />
        <path d='m344.285156 380.21875h30v40.035156h-30zm0 0' />
        <path d='m413.144531 380.21875h30v40.035156h-30zm0 0' />
    </svg>
);

const UMIcon = () => (
    <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
    >
        <g>
            <g>
                <path
                    d='M451.72,237.26c-17.422-8.71-50.087-8.811-51.469-8.811c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5
			c8.429,0.001,32.902,1.299,44.761,7.228c1.077,0.539,2.221,0.793,3.348,0.793c2.751,0,5.4-1.52,6.714-4.147
			C456.927,243.618,455.425,239.113,451.72,237.26z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M489.112,344.041l-30.975-8.85c-1.337-0.382-2.271-1.62-2.271-3.011v-10.339c2.52-1.746,4.924-3.7,7.171-5.881
			c10.89-10.568,16.887-24.743,16.887-39.915v-14.267l2.995-5.989c3.287-6.575,5.024-13.936,5.024-21.286v-38.65
			c0-4.142-3.358-7.5-7.5-7.5H408.27c-26.244,0-47.596,21.352-47.596,47.596v0.447c0,6.112,1.445,12.233,4.178,17.699l3.841,7.682
			v12.25c0,19.414,9.567,36.833,24.058,47.315l0.002,10.836c0,1.671,0,2.363-6.193,4.133l-15.114,4.318l-43.721-15.898
			c0.157-2.063-0.539-4.161-2.044-5.742l-13.971-14.678v-24.64c1.477-1.217,2.933-2.467,4.344-3.789
			c17.625-16.52,27.733-39.844,27.733-63.991v-19.678c5.322-11.581,8.019-23.836,8.019-36.457v-80.19c0-4.142-3.358-7.5-7.5-7.5
			H232.037c-39.51,0-71.653,32.144-71.653,71.653v16.039c0,12.621,2.697,24.876,8.019,36.457v16.931
			c0,28.036,12.466,53.294,32.077,69.946v25.22l-13.971,14.678c-1.505,1.581-2.201,3.679-2.044,5.742l-46.145,16.779
			c-3.344,1.216-6.451,2.863-9.272,4.858l-7.246-3.623c21.57-9.389,28.403-22.594,28.731-23.25c1.056-2.111,1.056-4.597,0-6.708
			c-5.407-10.814-6.062-30.635-6.588-46.561c-0.175-5.302-0.341-10.311-0.658-14.771c-2.557-35.974-29.905-63.103-63.615-63.103
			s-61.059,27.128-63.615,63.103c-0.317,4.461-0.483,9.47-0.658,14.773c-0.526,15.925-1.182,35.744-6.588,46.558
			c-1.056,2.111-1.056,4.597,0,6.708c0.328,0.656,7.147,13.834,28.76,23.234l-20.127,10.063C6.684,358.176,0,368.991,0,381.02
			v55.409c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V381.02c0-6.312,3.507-11.987,9.152-14.81l25.063-12.531l8.718,8.285
			c6.096,5.793,13.916,8.688,21.739,8.688c7.821,0,15.645-2.897,21.739-8.688l8.717-8.284l8.172,4.086
			c-3.848,6.157-6.032,13.377-6.032,20.94v57.725c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-57.725
			c0-10.296,6.501-19.578,16.178-23.097l48.652-17.691l20.253,30.381c2.589,3.884,6.738,6.375,11.383,6.835
			c0.518,0.051,1.033,0.076,1.547,0.076c4.098,0,8.023-1.613,10.957-4.546l12.356-12.356v78.124c0,4.142,3.358,7.5,7.5,7.5
			c4.142,0,7.5-3.358,7.5-7.5v-78.124l12.356,12.356c2.933,2.934,6.858,4.547,10.957,4.547c0.513,0,1.029-0.025,1.546-0.076
			c4.646-0.46,8.795-2.951,11.384-6.835l20.254-30.38l48.651,17.691c9.676,3.519,16.178,12.801,16.178,23.097v57.725
			c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-57.725c0-10.428-4.143-20.208-11.093-27.441l1.853-0.529
			c1.869-0.534,4.419-1.265,6.979-2.52l19.149,19.149v69.066c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-69.066
			l19.016-19.016c1.011,0.514,2.073,0.948,3.191,1.267l30.976,8.85c7.07,2.02,12.009,8.567,12.009,15.921v62.044
			c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-62.044C512,360.371,502.588,347.892,489.112,344.041z M48.115,330.794
			c-14.029-5.048-21.066-11.778-24.07-15.453c2.048-5.354,3.376-11.486,4.275-17.959c4.136,9.917,11.063,18.383,19.795,24.423
			V330.794z M91.08,351.092c-6.397,6.078-16.418,6.077-22.813-0.001l-6.975-6.628c1.177-2.205,1.824-4.705,1.824-7.324v-7.994
			c5.232,1.635,10.794,2.517,16.558,2.517c5.757,0,11.316-0.886,16.557-2.512l-0.001,7.988c0,2.62,0.646,5.121,1.824,7.327
			L91.08,351.092z M79.676,316.662c-22.396,0-40.615-18.22-40.615-40.615c0-4.142-3.358-7.5-7.5-7.5c-0.42,0-0.83,0.043-1.231,0.11
			c0.022-0.645,0.043-1.291,0.065-1.93c0.167-5.157,0.328-10.028,0.625-14.206c0.958-13.476,6.343-25.894,15.163-34.968
			c8.899-9.156,20.793-14.198,33.491-14.198s24.591,5.042,33.491,14.198c8.82,9.074,14.205,21.492,15.163,34.968
			c0.296,4.177,0.458,9.047,0.628,14.203c0.015,0.443,0.03,0.892,0.045,1.338c-8.16-12.572-20.762-21.837-37.045-27.069
			c-15.043-4.833-27.981-4.534-28.527-4.52c-1.964,0.055-3.828,0.877-5.191,2.291l-13.532,14.034
			c-2.875,2.982-2.789,7.73,0.193,10.605s7.73,2.788,10.605-0.193l11.26-11.677c9.697,0.474,40.894,4.102,53.027,30.819
			C116.738,302.04,99.816,316.662,79.676,316.662z M111.229,330.819l0.001-8.945c8.725-6.007,15.662-14.457,19.801-24.449
			c0.899,6.458,2.226,12.576,4.27,17.918C132.314,318.983,125.244,325.773,111.229,330.819z M183.403,209.145v-18.608
			c0-1.129-0.255-2.244-0.746-3.261c-4.826-9.994-7.273-20.598-7.273-31.518V139.72c0-31.239,25.415-56.653,56.653-56.653h104.769
			v72.692c0,10.92-2.447,21.524-7.273,31.518c-0.491,1.017-0.746,2.132-0.746,3.261v21.355c0,20.311-8.165,39.15-22.991,53.047
			c-1.851,1.734-3.772,3.36-5.758,4.875c-0.044,0.03-0.086,0.063-0.129,0.094c-13.889,10.545-30.901,15.67-48.667,14.519
			C213.201,281.965,183.403,248.897,183.403,209.145z M225.632,360.056c-0.052,0.052-0.173,0.175-0.418,0.149
			c-0.244-0.024-0.34-0.167-0.381-0.229l-23.325-34.988l7.506-7.887l35.385,24.187L225.632,360.056z M256.095,331.113
			l-40.615-27.762v-14c10.509,5.681,22.276,9.234,34.791,10.044c1.977,0.128,3.942,0.191,5.901,0.191
			c14.341,0,28.143-3.428,40.538-9.935v13.7L256.095,331.113z M287.357,359.978c-0.041,0.062-0.137,0.205-0.381,0.229
			c-0.245,0.031-0.365-0.098-0.418-0.149l-18.767-18.767l35.385-24.188l7.507,7.887L287.357,359.978z M424.308,353.65l-17.02-17.019
			c0.297-1.349,0.465-2.826,0.464-4.455l-0.001-3.165c4.723,1.55,9.701,2.47,14.852,2.624c0.578,0.018,1.151,0.026,1.727,0.026
			c5.692,0,11.248-0.86,16.536-2.501v3.02c0,1.496,0.188,2.962,0.542,4.371L424.308,353.65z M452.591,305.196
			c-7.949,7.714-18.45,11.788-29.537,11.446c-21.704-0.651-39.361-19.768-39.361-42.613v-14.021c0-1.165-0.271-2.313-0.792-3.354
			l-4.633-9.266c-1.697-3.395-2.594-7.195-2.594-10.991v-0.447c0-17.974,14.623-32.596,32.596-32.596h64.673v31.15
			c0,5.034-1.19,10.075-3.441,14.578l-3.786,7.572c-0.521,1.042-0.792,2.189-0.792,3.354v16.038
			C464.924,287.126,460.544,297.478,452.591,305.196z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M472.423,380.814c-4.142,0-7.5,3.358-7.5,7.5v48.115c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-48.115
			C479.923,384.173,476.565,380.814,472.423,380.814z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M39.577,390.728c-4.142,0-7.5,3.358-7.5,7.5v38.201c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-38.201
			C47.077,394.087,43.719,390.728,39.577,390.728z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M317.532,158.475c-28.366-28.366-87.715-22.943-111.917-19.295c-7.623,1.149-13.155,7.6-13.155,15.339v17.278
			c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-17.279c0-0.255,0.168-0.473,0.392-0.507
			c9.667-1.457,28.85-3.705,48.725-2.38c23.388,1.557,40.328,7.428,50.349,17.45c2.929,2.929,7.678,2.929,10.606,0
			C320.461,166.152,320.461,161.403,317.532,158.475z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M167.884,396.853c-4.142,0-7.5,3.358-7.5,7.5v32.077c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-32.077
			C175.384,400.212,172.026,396.853,167.884,396.853z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M344.306,396.853c-4.142,0-7.5,3.358-7.5,7.5v32.077c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-32.077
			C351.806,400.212,348.448,396.853,344.306,396.853z'
                />
            </g>
        </g>
    </svg>
);

const jsaEditBtnIcon = (
    <svg
        className='jsaEditBtnIcon'
        height='20pt'
        viewBox='0 -1 401.52289 401'
        width='20pt'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0' />
        <path d='m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0' />
    </svg>
);

const jsaPdfBtnIcon = (
    <svg
        className='jsaPdfBtnIcon'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 512 512'
        height='20pt'
        width='20pt'
    >
        <g>
            <g>
                <path
                    d='M494.479,138.557L364.04,3.018C362.183,1.09,359.621,0,356.945,0h-194.41c-21.757,0-39.458,17.694-39.458,39.442v137.789
			        H44.29c-16.278,0-29.521,13.239-29.521,29.513v147.744C14.769,370.761,28.012,384,44.29,384h78.787v88.627
			        c0,21.71,17.701,39.373,39.458,39.373h295.238c21.757,0,39.458-17.653,39.458-39.351V145.385
			        C497.231,142.839,496.244,140.392,494.479,138.557z M359.385,26.581l107.079,111.265H359.385V26.581z M44.29,364.308
			        c-5.42,0-9.828-4.405-9.828-9.82V206.744c0-5.415,4.409-9.821,9.828-9.821h265.882c5.42,0,9.828,4.406,9.828,9.821v147.744
			        c0,5.415-4.409,9.82-9.828,9.82H44.29z M477.538,472.649c0,10.84-8.867,19.659-19.766,19.659H162.535
			        c-10.899,0-19.766-8.828-19.766-19.68V384h167.403c16.278,0,29.521-13.239,29.521-29.512V206.744
			        c0-16.274-13.243-29.513-29.521-29.513H142.769V39.442c0-10.891,8.867-19.75,19.766-19.75h177.157v128
			        c0,5.438,4.409,9.846,9.846,9.846h128V472.649z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M132.481,249.894c-3.269-4.25-7.327-7.01-12.173-8.279c-3.154-0.846-9.923-1.269-20.308-1.269H72.596v84.577h17.077
			        v-31.904h11.135c7.731,0,13.635-0.404,17.712-1.212c3-0.654,5.952-1.99,8.856-4.01c2.904-2.019,5.298-4.798,7.183-8.336
			        c1.885-3.538,2.827-7.904,2.827-13.096C137.385,259.634,135.75,254.144,132.481,249.894z M117.856,273.173
			        c-1.288,1.885-3.067,3.269-5.337,4.154s-6.769,1.327-13.5,1.327h-9.346v-24h8.25c6.154,0,10.25,0.192,12.288,0.577
			        c2.769,0.5,5.058,1.75,6.865,3.75c1.808,2,2.712,4.539,2.712,7.615C119.789,269.096,119.144,271.288,117.856,273.173z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M219.481,263.452c-1.846-5.404-4.539-9.971-8.077-13.702s-7.789-6.327-12.75-7.789c-3.692-1.077-9.058-1.615-16.096-1.615
			        h-31.212v84.577h32.135c6.308,0,11.346-0.596,15.115-1.789c5.039-1.615,9.039-3.865,12-6.75c3.923-3.808,6.942-8.788,9.058-14.942
			        c1.731-5.039,2.596-11.039,2.596-18C222.25,275.519,221.327,268.856,219.481,263.452z M202.865,298.183
			        c-1.154,3.789-2.644,6.51-4.471,8.163c-1.827,1.654-4.125,2.827-6.894,3.519c-2.115,0.539-5.558,0.808-10.327,0.808h-12.75v0
			        v-56.019h7.673c6.961,0,11.635,0.269,14.019,0.808c3.192,0.692,5.827,2.019,7.904,3.981c2.077,1.962,3.692,4.692,4.846,8.192
			        c1.154,3.5,1.731,8.519,1.731,15.058C204.596,289.231,204.019,294.394,202.865,298.183z'
                />
            </g>
        </g>
        <g>
            <g>
                <polygon points='294.827,254.654 294.827,240.346 236.846,240.346 236.846,324.923 253.923,324.923 253.923,288.981 289.231,288.981 289.231,274.673 253.923,274.673 253.923,254.654 		' />
            </g>
        </g>
    </svg>
);

const jsaDeleteBtnIcon = (
    <svg
        className='jsaDeleteBtnIcon'
        height='20pt'
        width='20pt'
        viewBox='-40 0 427 427.00131'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0' />
        <path d='m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0' />
        <path d='m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0' />
        <path d='m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0' />
    </svg>
);

const jsaAppointmentDetailsIcon = (
    <svg
        className='jsaAppointmentDetailsIcon'
        height='20pt'
        width='20pt'
        viewBox='0 0 512.144 512.144'
        xmlns='http://www.w3.org/2000/svg'
    >
        <title>Appointment Details</title>
        <g>
            <g>
                <path d='m410.856 247.874v-45.37h-339.679v209.808l159.08.002v-15h-14.208c0-6.249 0-43.694 0-49.939h22.288v-15h-22.288v-49.93l64.936-.005.002-64.936h49.931v31.95h15v-31.95h49.939v30.37zm-259.743 34.565h49.934v49.936h-49.934zm64.936-64.935h49.936v49.936h-49.936zm-64.936 0h49.936v49.936h-49.936zm-64.936 0h49.937v49.936h-49.937zm0 64.935h49.937v49.936h-49.937zm49.936 114.873h-49.936v-49.937h49.937v49.937zm15 0v-49.937h49.934v49.937z' />
                <path d='m374.326 267.444c-67.464 0-122.35 54.886-122.35 122.35 0 30.755 11.46 60.152 32.27 82.777l11.041-10.154c-18.257-19.849-28.311-45.64-28.311-72.623 0-59.192 48.157-107.35 107.35-107.35s107.351 48.157 107.351 107.35-48.157 107.35-107.351 107.35c-25.173 0-49.639-8.892-68.891-25.037l-9.639 11.494c21.949 18.406 49.838 28.543 78.529 28.543 67.464 0 122.351-54.886 122.351-122.35s-54.886-122.35-122.35-122.35z' />
                <path d='m366.358 306.973v97.676h70.152v-15h-55.152v-82.676z' />
                <path d='m30.467 175.714h40.71v-15h-40.71v-111.87h32.66v37.29h.001v.003h60.208v-.003h.001v-37.29h38.31v37.29h.005v.003h60.207v-37.293h38.316v37.293h60.207v-.003h.005v-37.29h38.31v37.29h.001v.003h60.208v-.003h.001v-37.29h32.66v111.87h-365.39v15h365.39v96.67h15v-238.54h-47.661v-15.165l-13.893-18.679h-32.423l-13.893 18.679v15.165h-38.315v-15.165l-13.893-18.679h-32.422l-13.893 18.679v15.165h-38.316v-15.165l-13.892-18.679h-32.422l-13.893 18.679v15.165h-38.315v-15.165l-13.893-18.679h-32.422l-13.893 18.679v15.165h-47.661v417.811h224.59v-15h-209.59zm349.66-160.714h17.349l6.43 8.646v47.488h-30.208v-47.488zm-104.952 8.646 6.43-8.646h17.348l6.43 8.646v47.488h-30.205v-37.29h-.002v-10.198zm-92.094-8.646h17.348l6.43 8.646v10.198h-.002v37.29h-30.205v-47.488zm-98.523 0h17.349l6.43 8.646v47.488h-30.209v-47.488z' />
            </g>
            <g>
                <path d='m293.017 136.068h-15v-15h15zm-45 0h-15v-15h15zm-45 0h-15v-15h15z' />
            </g>
            <g>
                <path d='m287.618 389.649h15v15h-15z' />
            </g>
            <g>
                <path d='m366.931 462.292h15v15h-15z' />
            </g>
        </g>
    </svg>
);
const enrollmentIcon = (
    <svg
        id='Capa_1'
        className='enrollmentIcon'
        enableBackground='new 0 0 512 512'
        height='512'
        viewBox='0 0 512 512'
        width='512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g>
            <g>
                <path
                    d='m444.243 184.689v239.62c0 16.57-13.43 30-30 30h-377c-16.57 0-30-13.43-30-30v-239.62c0-16.57 13.43-30 30-30h377c16.57 0 30 13.43 30 30z'
                    fill='#b5adb6'
                />
                <path
                    d='m171.867 349.311h-89.624c-16.569 0-30-13.431-30-30v-89.624c0-16.569 13.431-30 30-30h89.624c16.569 0 30 13.431 30 30v89.624c0 16.569-13.431 30-30 30z'
                    fill='#fff'
                />
                <circle
                    cx='127.055'
                    cy='265.913'
                    fill='#d78878'
                    r='36.227'
                />
                <path
                    d='m82.243 349.311h89.624c2.854 0 5.61-.407 8.225-1.151-3.674-26.01-26.014-46.02-53.038-46.02s-49.363 20.01-53.038 46.02c2.616.744 5.373 1.151 8.227 1.151z'
                    fill='#fd9468'
                />
                <g>
                    <g>
                        <path
                            d='m444.243 184.689v98.99c-13 4.32-26.9 6.66-41.33 6.66-72.41 0-131.32-58.91-131.32-131.32 0-1.45.02-2.89.07-4.33h142.58c16.57 0 30 13.43 30 30z'
                            fill='#a79ba7'
                        />
                        <circle
                            cx='402.916'
                            cy='159.014'
                            fill='#98d5b9'
                            r='101.327'
                        />
                    </g>
                </g>
            </g>
            <path d='m399.5 401.812h-347c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h347c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zm0-30h-347c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h347c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zm45-97.748c-4.142 0-7.5 3.358-7.5 7.5v142.748c0 12.407-10.093 22.5-22.5 22.5h-377c-12.407 0-22.5-10.093-22.5-22.5v-239.624c0-12.407 10.093-22.5 22.5-22.5h234.345c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-234.345c-20.678 0-37.5 16.822-37.5 37.5v239.624c0 20.678 16.822 37.5 37.5 37.5h377c20.678 0 37.5-16.822 37.5-37.5v-142.748c0-4.142-3.358-7.5-7.5-7.5zm-41.327-223.876c-60.008 0-108.828 48.82-108.828 108.827 0 11.564 1.82 22.709 5.176 33.173h-52.021c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h58.107c2.604 5.252 5.615 10.268 9 15h-67.107c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h80.042c19.596 18.964 46.272 30.655 75.63 30.655 60.007 0 108.827-48.82 108.827-108.828.001-60.007-48.819-108.827-108.826-108.827zm0 202.655c-51.737 0-93.828-42.091-93.828-93.828 0-51.736 42.091-93.827 93.828-93.827 51.736 0 93.827 42.091 93.827 93.827 0 51.737-42.091 93.828-93.827 93.828zm-330.858 102.552c2.286.638 5.78 1.313 10.185 1.417h89.625c19.077.373 37.894-16.669 37.5-37.5v-89.624c0-20.678-16.822-37.5-37.5-37.5h-89.625c-20.678 0-37.5 16.822-37.5 37.5v89.624c0 17.147 11.573 31.633 27.315 36.083zm11.082-13.583c5.965-18.775 23.673-32.171 43.915-32.171 20.243 0 37.951 13.396 43.915 32.171zm15.188-75.897c0-15.84 12.887-28.727 28.727-28.727s28.727 12.887 28.727 28.727-12.887 28.727-28.727 28.727-28.727-12.888-28.727-28.727zm-38.585-36.227c0-12.407 10.093-22.5 22.5-22.5h89.625c12.407 0 22.5 10.093 22.5 22.5v89.624c0 7.381-3.573 13.942-9.079 18.048-5.129-16.206-16.845-29.396-31.804-36.64 10.501-7.994 17.297-20.619 17.297-34.805 0-24.111-19.616-43.727-43.727-43.727s-43.727 19.616-43.727 43.727c0 14.186 6.795 26.811 17.297 34.805-14.958 7.244-26.674 20.434-31.803 36.64-5.506-4.106-9.079-10.667-9.079-18.048zm380.6-97.001-52.03 52.03c-.728.727-1.909.727-2.637 0l-20.188-20.188c-2.929-2.929-7.678-2.929-10.606 0-2.929 2.929-2.929 7.678 0 10.606l20.188 20.188c3.288 3.288 7.606 4.932 11.925 4.932s8.637-1.644 11.925-4.932l52.03-52.03c2.929-2.929 2.929-7.678 0-10.606-2.93-2.929-7.679-2.929-10.607 0zm-41.1 179.125h-152c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h152c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zm0 30h-152c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h152c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z' />
        </g>
    </svg>
);

const emergencyIcon = (
    <svg
        id='Capa_1'
        className='emergencyIcon'
        enableBackground='new 0 0 512 512'
        height='512'
        viewBox='0 0 512 512'
        width='512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g>
            <g>
                <path
                    d='m7.5 377.22h497v32.325h-497z'
                    fill='#d0e2e7'
                />
            </g>
            <g>
                <path
                    d='m441.87 249.939-30.305-143.443h-404.065v270.724h497v-96.976z'
                    fill='#f1f4f6'
                />
            </g>
            <g>
                <path
                    d='m441.87 249.939-30.305-143.443h-34.607l30.469 134.123c1.34 5.9 5.254 10.889 10.666 13.595l40.893 20.446c6.845 3.422 11.168 10.418 11.168 18.07v84.489h34.346v-96.976z'
                    fill='#d0e2e7'
                />
            </g>
            <g>
                <path
                    d='m328.732 249.939v-111.118h55.559l25.254 111.118z'
                    fill='#b1e4f9'
                />
            </g>
            <g>
                <path
                    d='m384.291 138.821h-19.193l25.254 111.118h19.193z'
                    fill='#90d8f9'
                />
            </g>
            <g>
                <path
                    d='m235.797 138.821h60.61v111.118h-60.61z'
                    fill='#b1e4f9'
                />
            </g>
            <g>
                <g>
                    <circle
                        cx='404.494'
                        cy='393.382'
                        fill='#86a0af'
                        r='60.61'
                    />
                </g>
                <g>
                    <path
                        d='m438.799 343.42c6.711 9.756 10.648 21.568 10.648 34.305 0 33.474-27.136 60.61-60.61 60.61-12.736 0-24.549-3.936-34.305-10.648 10.928 15.884 29.225 26.305 49.962 26.305 33.474 0 60.61-27.136 60.61-60.61 0-20.737-10.421-39.034-26.305-49.962z'
                        fill='#738b95'
                    />
                </g>
                <g>
                    <circle
                        cx='404.494'
                        cy='393.382'
                        fill='#d0e2e7'
                        r='17.173'
                    />
                </g>
            </g>
            <g>
                <g>
                    <circle
                        cx='107.506'
                        cy='393.382'
                        fill='#86a0af'
                        r='60.61'
                    />
                </g>
                <g>
                    <path
                        d='m141.811 343.42c6.711 9.756 10.648 21.568 10.648 34.305 0 33.474-27.136 60.61-60.61 60.61-12.736 0-24.549-3.936-34.305-10.648 10.928 15.884 29.225 26.305 49.962 26.305 33.474 0 60.61-27.136 60.61-60.61 0-20.737-10.421-39.034-26.305-49.962z'
                        fill='#738b95'
                    />
                </g>
                <g>
                    <circle
                        cx='107.506'
                        cy='393.382'
                        fill='#d0e2e7'
                        r='17.173'
                    />
                </g>
            </g>
            <g>
                <path
                    d='m188.319 190.339h-51.518v-51.518h-34.346v51.518h-51.518v34.346h51.518v51.518h34.346v-51.518h51.518z'
                    fill='#dd636e'
                />
            </g>
            <g>
                <path
                    d='m286.305 106.496h-60.61l10.102-48.488h40.406z'
                    fill='#dd636e'
                />
            </g>
            <g>
                <path d='m204.5 402.045h-29.454c.362-2.839.57-5.726.57-8.663s-.208-5.823-.57-8.663h111.8c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-115.475c-9.637-25.925-34.626-44.447-63.865-44.447s-54.227 18.522-63.864 44.447h-28.642v-255.723h89.214c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-96.714c-4.143 0-7.5 3.358-7.5 7.5v303.049c0 4.142 3.357 7.5 7.5 7.5h36.142c9.637 25.925 34.625 44.447 63.864 44.447s54.228-18.522 63.865-44.447h33.129c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5zm-189.5 0v-17.325h24.967c-.362 2.839-.57 5.726-.57 8.663s.208 5.823.57 8.663h-24.967zm92.506 44.447c-29.284 0-53.109-23.825-53.109-53.109s23.825-53.11 53.109-53.11c29.285 0 53.11 23.825 53.11 53.11s-23.825 53.109-53.11 53.109z' />
                <path d='m507.767 273.493-59.318-28.703-29.545-139.844c-.732-3.468-3.793-5.95-7.338-5.95h-119.162l-8.858-42.518c-.725-3.478-3.79-5.97-7.343-5.97h-40.406c-3.553 0-6.618 2.493-7.343 5.97l-8.858 42.518h-80.36c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h266.248l29.048 137.493c.479 2.27 1.982 4.19 4.071 5.201l58.397 28.257v14.062h-12.703c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h12.703v17.325h-12.703c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h12.703v23.386h-28.642c-9.637-25.925-34.625-44.447-63.864-44.447s-54.228 18.522-63.865 44.447h-18.761c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h15.086c-.362 2.839-.57 5.726-.57 8.663s.208 5.823.57 8.663h-97.459c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h101.134c9.637 25.925 34.625 44.447 63.865 44.447 29.239 0 54.227-18.522 63.864-44.447h36.142c4.143 0 7.5-3.358 7.5-7.5v-32.326-96.976c0-2.876-1.645-5.498-4.233-6.751zm-272.848-174.497 6.977-33.488h28.209l6.977 33.488zm169.575 347.496c-29.285 0-53.11-23.825-53.11-53.109s23.825-53.11 53.11-53.11c29.284 0 53.109 23.825 53.109 53.11s-23.825 53.109-53.109 53.109zm92.506-44.447h-24.967c.362-2.839.57-5.726.57-8.663s-.208-5.823-.57-8.663h24.967z' />
                <path d='m328.731 257.439h80.813c2.281 0 4.438-1.038 5.861-2.821 1.424-1.783 1.958-4.116 1.452-6.341l-25.254-111.118c-.776-3.415-3.812-5.838-7.313-5.838h-55.56c-4.143 0-7.5 3.358-7.5 7.5v111.118c.001 4.142 3.359 7.5 7.501 7.5zm7.5-111.118h42.073l21.845 96.118h-63.918z' />
                <path d='m328.731 289.764h20.203c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-20.203c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z' />
                <path d='m235.797 257.439h60.609c4.143 0 7.5-3.358 7.5-7.5v-111.118c0-4.142-3.357-7.5-7.5-7.5h-60.609c-4.143 0-7.5 3.358-7.5 7.5v111.118c0 4.142 3.357 7.5 7.5 7.5zm7.5-111.118h45.609v96.118h-45.609z' />
                <path d='m228.297 346.915c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-64.65c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5z' />
                <path d='m404.494 368.709c-13.604 0-24.673 11.068-24.673 24.673s11.068 24.672 24.673 24.672 24.673-11.068 24.673-24.672-11.068-24.673-24.673-24.673zm0 34.346c-5.334 0-9.673-4.339-9.673-9.672s4.339-9.673 9.673-9.673 9.673 4.339 9.673 9.673-4.339 9.672-9.673 9.672z' />
                <path d='m107.506 368.709c-13.604 0-24.673 11.068-24.673 24.673s11.068 24.672 24.673 24.672 24.673-11.068 24.673-24.672-11.069-24.673-24.673-24.673zm0 34.346c-5.334 0-9.673-4.339-9.673-9.672s4.339-9.673 9.673-9.673 9.673 4.339 9.673 9.673-4.339 9.672-9.673 9.672z' />
                <path d='m136.801 131.321h-34.346c-4.143 0-7.5 3.358-7.5 7.5v44.018h-44.018c-4.143 0-7.5 3.358-7.5 7.5v34.346c0 4.142 3.357 7.5 7.5 7.5h44.019v44.018c0 4.142 3.357 7.5 7.5 7.5h34.346c4.143 0 7.5-3.358 7.5-7.5v-44.018h44.019c4.143 0 7.5-3.358 7.5-7.5v-34.346c0-4.142-3.357-7.5-7.5-7.5h-44.019v-44.018c-.001-4.142-3.359-7.5-7.501-7.5zm44.018 66.518v19.346h-44.019c-4.143 0-7.5 3.358-7.5 7.5v44.018h-19.346v-44.018c0-4.142-3.357-7.5-7.5-7.5h-44.017v-19.346h44.019c4.143 0 7.5-3.358 7.5-7.5v-44.018h19.346v44.018c0 4.142 3.357 7.5 7.5 7.5z' />
            </g>
        </g>
    </svg>
);

const psychIcon = (
    <svg
        className='psychIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width='512'
        height='512'
        viewBox='0 0 53 58'
        version='1.1'
    >
        <title>050 - Human Brain</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id='Page-1'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
        >
            <g
                id='050---Human-Brain'
                fillRule='nonzero'
            >
                <path
                    d='M18.72,50.3 C22.149,51.851 23.652,58 23.652,58 L48.746,57.931 C48.2755957,56.9544122 47.7410951,56.0100165 47.146,55.104 C46.6725523,54.1351747 46.2756732,53.1307732 45.959,52.1 C45.3713088,50.1113891 44.9643241,48.073788 44.743,46.012 C44.3709743,42.844112 44.8486519,39.634284 46.127,36.712 C47.254,34.142 49.211,32.106 50.703,29.753 C52.1821574,27.4555352 52.9787015,24.7853611 53,22.053 C53.056116,19.285616 52.7166887,16.5244021 51.992,13.853 C51.0439103,10.6166836 49.0658224,7.77805373 46.358,5.768 C41.4,1.88 36.342,-0.294 29.938,0.032 C26.7328989,0.255128449 23.5484062,0.712347803 20.41,1.4 C16.992,2.088 13.373,3.366 10.92,5.956 C9.24666038,7.74409793 7.95386958,9.85338818 7.12,12.156 C6.72915176,13.3014161 6.41118297,14.470419 6.168,15.656 C5.75858569,16.9487526 5.26451756,18.2131528 4.689,19.441 C4.5196763,19.814028 4.44579184,20.2233135 4.474,20.632 C4.666,22.016 6.742,22.611 6.759,24.038 C6.73675722,24.3532587 6.63974717,24.6586861 6.476,24.929 C5.25897289,27.4999033 3.76549632,29.930575 2.022,32.178 C1.61,32.683 0.774,33.678 0.878,34.392 C0.952,34.899 1.56,35.32 1.935,35.599 C2.735,36.193 4.364,36.599 4.567,37.671 C4.67208167,38.2169291 4.60607672,38.7819874 4.378,39.289 C3.825,40.456 3.212,41.078 3.647,41.444 C4.082,41.81 5.247,42.689 5.247,42.689 C5.247,42.689 4.14,44.103 4.753,44.537 C5.513,45.077 6.481,45.326 6.739,46.337 C6.81580147,47.1381317 6.73563877,47.9465522 6.503,48.717 C6.42489413,49.4709685 6.52349984,50.2327661 6.791,50.942 C7.15504357,52.3575719 8.57041671,53.2344064 10,52.93 C12.9521039,52.2117262 15.8630511,51.3337685 18.72,50.3'
                    id='Shape'
                    fill='#35495E'
                />
                <path
                    d='M39.672,42.45 C38.4378166,42.4497236 37.3262845,41.703302 36.859,40.561 C36.587,39.902 35.614,38.961 33.8,37.6 C30.864,35.4 30.117,31.465 31.8,27.073 L32.4,25.522 L49.123,28.6 L45.849,31.88 L45.833,31.88 C44.355,33.383 43,35.126 43,37 C43.0164904,38.1689663 42.8397786,39.3326289 42.477,40.444 C42.0764608,41.6483941 40.9462245,42.4581277 39.677,42.45 L39.672,42.45 Z'
                    id='Shape'
                    fill='#2C3E50'
                />
                <path
                    d='M40.8,32.858 C39.6030661,32.8607566 38.413839,32.6664937 37.28,32.283 C36.4748802,32.0104528 35.7014275,31.6520562 34.973,31.214 C33.2144113,30.0936321 31.5994256,28.7624192 30.164,27.25 C29.4324082,26.5083402 28.5107195,25.9824518 27.5,25.73 C26.9722155,25.6070273 26.4343265,25.5323856 25.893,25.507 C25.693,25.496 25.469,25.491 25.244,25.491 C23.0186677,25.5779513 20.8015084,25.8117936 18.607,26.191 L17.246,26.391 C16.6496683,26.4753463 16.0482631,26.5187811 15.446,26.521 C15.257,26.521 15.073,26.521 14.896,26.507 C14.0116505,26.4863496 13.1368215,26.3194259 12.307,26.013 C9.88724025,25.0895436 8.20682398,22.8659429 7.979,20.286 L7.958,20.144 C7.85184477,19.3850637 7.83037964,18.616679 7.894,17.853 C7.91853809,17.2788823 7.99146331,16.7078578 8.112,16.146 C8.138,16.032 8.529,14.37 8.834,13.362 C8.904,13.137 8.951,12.987 8.998,12.857 C9.239,12.218 9.487,11.641 9.742,11.12 C10.4279573,9.73021761 11.3159199,8.44966439 12.377,7.32 C13.468227,6.22350097 14.7654173,5.35349641 16.194,4.76 C16.9040538,4.44837747 17.6327924,4.18119557 18.376,3.96 C19.161,3.725 19.976,3.521 20.808,3.355 C21.733,3.164 22.702,2.98 23.682,2.807 C24.291,2.694 24.925,2.591 25.558,2.498 C26.295,2.385 27.032,2.292 27.779,2.209 C28.501,2.133 29.199,2.07 29.898,2.038 C29.941,2.038 29.998,2.03 30.059,2.027 C30.446,2.01 30.834,2 31.21,2 C31.51,2 31.801,2.011 32.085,2.021 C32.8279677,2.04632447 33.5686874,2.11712364 34.303,2.233 C36.4775511,2.57331726 38.5790668,3.27821754 40.519,4.318 C41.046,4.588 41.558,4.88 42.064,5.203 C42.7746667,5.631 43.5556667,6.16433333 44.407,6.803 C44.645,6.978 44.879,7.158 45.123,7.35 C45.5772543,7.69483325 46.0085052,8.06896262 46.414,8.47 C48.1549151,10.0718689 49.4185531,12.1242856 50.065,14.4 C50.4654007,15.8418927 50.7331811,17.3173629 50.865,18.808 C50.936,19.581 50.975,20.286 50.985,20.973 C51,21.29 51,21.64 51,22 C50.996751,22.4159355 50.9690364,22.8313196 50.917,23.244 C50.8450168,24.0530853 50.6819859,24.8514673 50.431,25.624 C50.1003533,26.7004137 49.6260809,27.7273312 49.021,28.677 C47.9204846,30.3524751 46.3153866,31.634312 44.438,32.337 C43.2529477,32.6720226 42.0284517,32.8472388 40.797,32.858 L40.8,32.858 Z'
                    id='Shape'
                    fill='#2C3E50'
                />
                <path
                    d='M33.67,27.79 C33.01,29.51 31.89,33.67 35,36 C37.328,37.746 38.3,38.815 38.708,39.8 C38.8527158,40.1933506 39.2273731,40.4547208 39.6465,40.4547208 C40.0656269,40.4547208 40.4402842,40.1933506 40.585,39.8 C40.8776506,38.8961386 41.0178983,37.9498891 41,37 C41,34.12 43.08,31.75 44.99,29.9 C45,29.9 45.01,29.89 45.02,29.88 L33.67,27.79 Z'
                    id='Shape'
                    fill='#DF4D60'
                />
                <path
                    d='M48.99,21 C48.98,20.32 48.94,19.65 48.88,19 C48.7571575,17.627 48.5094669,16.2680487 48.14,14.94 C47.5867325,12.9930522 46.4989377,11.240109 45,9.88 C44.6506332,9.53689242 44.2798915,9.21625091 43.89,8.92 C43.66,8.74 43.44,8.57 43.21,8.4 C42.46,7.84 41.72,7.33 40.99,6.89 C40.52,6.59 40.06,6.33 39.59,6.09 C37.8457658,5.15316372 35.9558682,4.51756309 34,4.21 C33.3412224,4.1056673 32.6766182,4.04221264 32.01,4.02 C31.75,4.01 31.48,4 31.21,4 C30.86,4 30.5,4.01 30.14,4.03 C30.09,4.03 30.04,4.04 29.99,4.04 C29.33,4.07 28.67,4.13 28,4.2 C27.28,4.28 26.57,4.37 25.85,4.48 C25.24,4.57 24.63,4.67 24.03,4.78 C23.07,4.95 22.12,5.13 21.2,5.32 C20.4,5.48 19.65,5.67 18.95,5.88 C18.2861196,6.07664984 17.6349014,6.31376005 17,6.59 C15.8111949,7.07668428 14.7304399,7.79378903 13.82,8.7 C12.8974109,9.68048824 12.1256486,10.7926348 11.53,12 C11.29,12.49 11.07,13.01 10.87,13.54 C10.83,13.65 10.79,13.78 10.74,13.94 C10.45,14.9 10.06,16.56 10.06,16.56 C9.95944741,17.037431 9.89923511,17.5224744 9.88,18.01 C9.82403126,18.6704236 9.84753267,19.3351777 9.95,19.99 L9.95,20 C10.0810688,21.8534968 11.2686319,23.4654676 13,24.14 C13.6380149,24.3736036 14.3106582,24.498668 14.99,24.51 C15.6483493,24.5384457 16.3079152,24.5049652 16.96,24.41 C19.9418755,23.8508064 22.9664042,23.5496919 26,23.51 C26.6671412,23.5429303 27.3298875,23.636652 27.98,23.79 C29.3365713,24.126419 30.574846,24.8285692 31.56,25.82 C32.8874203,27.219906 34.3780833,28.4554104 36,29.5 C38.3746087,30.9409226 41.2599697,31.2732869 43.9,30.41 C45.2983586,29.8419313 46.4934805,28.8663216 47.33,27.61 C47.8468647,26.7986377 48.2505894,25.9205365 48.53,25 C48.7398104,24.3543593 48.8740403,23.6865655 48.93,23.01 C48.9735614,22.6750412 48.9969369,22.3377656 49,22 C49,21.66 49,21.33 48.99,21 Z'
                    id='Shape'
                    fill='#FB7B76'
                />
                <path
                    d='M15,17 C14.9950578,18.6548028 13.6548028,19.9950578 12,20 L9.95,20 L9.95,19.99 C9.84753267,19.3351777 9.82403126,18.6704236 9.88,18.01 C9.91943229,18.0017152 9.95974034,17.9983562 10,18 L12,18 C12.5522847,18 13,17.5522847 13,17 C13,16.4477153 13.4477153,16 14,16 C14.5522847,16 15,16.4477153 15,17 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M15,23 L15,24.41 C15.0016387,24.4436447 14.9982685,24.4773461 14.99,24.51 C14.3106582,24.498668 13.6380149,24.3736036 13,24.14 L13,23 C13,22.4477153 13.4477153,22 14,22 C14.5522847,22 15,22.4477153 15,23 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M21,21 L20,21 C18.3431458,21 17,19.6568542 17,18 L17,17 C17,15.3431458 18.3431458,14 20,14 L21,14 C21.5522847,14 22,14.4477153 22,15 C22,15.5522847 21.5522847,16 21,16 L20,16 C19.4477153,16 19,16.4477153 19,17 L19,18 C19,18.5522847 19.4477153,19 20,19 L21,19 C21.5522847,19 22,19.4477153 22,20 C22,20.5522847 21.5522847,21 21,21 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M16,13 C16,13.5522847 15.5522847,14 15,14 L11.08,14 C10.963998,14.0004065 10.8488561,13.9800873 10.74,13.94 C10.79,13.78 10.83,13.65 10.87,13.54 C11.07,13.01 11.29,12.49 11.53,12 L15,12 C15.5522847,12 16,12.4477153 16,13 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M21,11 C21,11.5522847 20.5522847,12 20,12 C18.3451972,11.9950578 17.0049422,10.6548028 17,9 L17,6.59 C17.6349014,6.31376005 18.2861196,6.07664984 18.95,5.88 C18.981979,5.98027453 18.9988309,6.08475614 19,6.19 L19,9 C19,9.55228475 19.4477153,10 20,10 C20.5522847,10 21,10.4477153 21,11 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M25,19 L24,19 C23.4477153,19 23,18.5522847 23,18 C23,17.4477153 23.4477153,17 24,17 L25,17 C25.5522847,17 26,16.5522847 26,16 L26,14 C26,13.4477153 26.4477153,13 27,13 C27.5522847,13 28,13.4477153 28,14 L28,16 C28,17.6568542 26.6568542,19 25,19 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M30,14 C29.4477153,14 29,13.5522847 29,13 L29,12 C29,11.4477153 28.5522847,11 28,11 L26,11 C25.4477153,11 25,11.4477153 25,12 L25,13 C25,13.5522847 24.5522847,14 24,14 C23.4477153,14 23,13.5522847 23,13 L23,12 C23,10.3431458 24.3431458,9 26,9 L28,9 C29.6568542,9 31,10.3431458 31,12 L31,13 C31,13.5522847 30.5522847,14 30,14 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M26,5 L26,6 C26,6.55228475 25.5522847,7 25,7 C24.4477153,7 24,6.55228475 24,6 L24,5 C23.9994578,4.92561128 24.0095602,4.85152754 24.03,4.78 C24.63,4.67 25.24,4.57 25.85,4.48 C25.9503889,4.63465571 26.0025951,4.81563738 26,5 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M30,4.1 L30,6 C30,6.55228475 29.5522847,7 29,7 C28.4477153,7 28,6.55228475 28,6 L28,4.2 C28.67,4.13 29.33,4.07 29.99,4.04 C29.9981444,4.05889467 30.0015762,4.07948523 30,4.1 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M36,9 C36,9.55228475 35.5522847,10 35,10 L33,10 C32.4477153,10 32,9.55228475 32,9 L32,4.09 C31.9983902,4.06622368 32.0017972,4.04237451 32.01,4.02 C32.6766182,4.04221264 33.3412224,4.1056673 34,4.21 L34,8 L35,8 C35.5522847,8 36,8.44771525 36,9 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M28,22 L28,23.6 C27.9988162,23.663791 27.9921246,23.7273606 27.98,23.79 C27.3298875,23.636652 26.6671412,23.5429303 26,23.51 L26,22 C26,21.4477153 26.4477153,21 27,21 C27.5522847,21 28,21.4477153 28,22 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M34,22 L33,22 C31.3431458,22 30,20.6568542 30,19 L30,18 C30,17.4477153 30.4477153,17 31,17 C31.5522847,17 32,17.4477153 32,18 L32,19 C32,19.5522847 32.4477153,20 33,20 L34,20 C34.5522847,20 35,20.4477153 35,21 C35,21.5522847 34.5522847,22 34,22 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M38,18 L37,18 C35.3431458,18 34,16.6568542 34,15 C34,13.3431458 35.3431458,12 37,12 L38,12 C38.5522847,12 39,12.4477153 39,13 C39,13.5522847 38.5522847,14 38,14 L37,14 C36.4477153,14 36,14.4477153 36,15 C36,15.5522847 36.4477153,16 37,16 L38,16 C38.5522847,16 39,16.4477153 39,17 C39,17.5522847 38.5522847,18 38,18 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M41,7 L41,10 C41,10.5522847 40.5522847,11 40,11 C39.4477153,11 39,10.5522847 39,10 L39,7 C39.0008198,6.60710057 39.231641,6.25108826 39.59,6.09 C40.06,6.33 40.52,6.59 40.99,6.89 C40.9987446,6.92597207 41.0021145,6.96304074 41,7 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M45,9.88 L45,12 C44.9950578,13.6548028 43.6548028,14.9950578 42,15 C41.4477153,15 41,14.5522847 41,14 C41,13.4477153 41.4477153,13 42,13 C42.5522847,13 43,12.5522847 43,12 L43,9.01 C43.0006878,8.78905055 43.0745323,8.57454984 43.21,8.4 C43.44,8.57 43.66,8.74 43.89,8.92 C44.2798915,9.21625091 44.6506332,9.53689242 45,9.88 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M40,23 L39,23 C38.4477153,23 38,22.5522847 38,22 C38,21.4477153 38.4477153,21 39,21 L40,21 C40.5522847,21 41,20.5522847 41,20 L41,18 C41,17.4477153 41.4477153,17 42,17 C42.5522847,17 43,17.4477153 43,18 L43,20 C43,21.6568542 41.6568542,23 40,23 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M43,26 C43,26.5522847 42.5522847,27 42,27 L39,27 C38.4477153,27 38,27.4477153 38,28 L38,30 C37.9995799,30.1340313 37.9723807,30.2666273 37.92,30.39 C37.2499704,30.1629577 36.6062758,29.8645785 36,29.5 L36,28 C36.0049422,26.3451972 37.3451972,25.0049422 39,25 L42,25 C42.2652165,25 42.5195704,25.1053568 42.7071068,25.2928932 C42.8946432,25.4804296 43,25.7347835 43,26 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M48.99,21 L46,21 C45.4477153,21 45,20.5522847 45,20 C45,19.4477153 45.4477153,19 46,19 L48.88,19 C48.94,19.65 48.98,20.32 48.99,21 Z'
                    id='Shape'
                    fill='#FF5364'
                />
                <path
                    d='M48.93,23.01 C48.8740403,23.6865655 48.7398104,24.3543593 48.53,25 L46,25 C45.4477153,25 45,24.5522847 45,24 C45,23.4477153 45.4477153,23 46,23 L48.79,23 C48.8368954,22.9979798 48.8838679,23.001335 48.93,23.01 Z'
                    id='Shape'
                    fill='#FF5364'
                />
            </g>
        </g>
    </svg>
);

const inpatientIcon = (
    <svg
        id='Capa_1'
        className='inpatientIcon'
        enableBackground='new 0 0 512 512'
        height='512'
        viewBox='0 0 512 512'
        width='512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g>
            <g>
                <path
                    d='m395.94 192.59h-374.929c-7.427 0-13.448 6.021-13.448 13.448v209.723h401.824v-209.724c.001-7.427-6.02-13.447-13.447-13.447z'
                    fill='#eedfda'
                />
            </g>
            <g>
                <path
                    d='m395.827 192.59h-21.944c7.49 0 13.561 6.071 13.561 13.561v209.61h21.944v-209.61c0-7.49-6.072-13.561-13.561-13.561z'
                    fill='#c9beb9'
                />
            </g>
            <g>
                <path
                    d='m363.517 308.273c-.97-4.498-.754-9.171.639-13.557 2.017-6.354 3.108-13.119 3.108-20.141v-78.225c0-6.959-1.07-13.668-3.052-19.973-1.373-4.367-1.583-9.016-.618-13.491l5.577-25.867c1.1-5.101-3.435-9.636-8.536-8.536l-25.148 5.422c-4.601.992-9.384.749-13.851-.733-6.58-2.184-13.613-3.373-20.926-3.373h-184.783c-7.313 0-14.346 1.189-20.926 3.373-4.467 1.483-9.25 1.725-13.851.733l-25.148-5.422c-5.101-1.1-9.636 3.435-8.536 8.536l5.577 25.867c.965 4.475.755 9.124-.618 13.491-1.982 6.305-3.052 13.014-3.052 19.973v78.225c0 7.022 1.091 13.787 3.108 20.141 1.393 4.386 1.608 9.059.639 13.557l-5.654 26.227c-1.1 5.101 3.435 9.636 8.536 8.536l26.227-5.654c4.498-.97 9.171-.754 13.557.639 6.354 2.017 13.119 3.108 20.141 3.108h184.783c7.022 0 13.787-1.091 20.141-3.108 4.386-1.393 9.059-1.608 13.557-.639l26.227 5.654c5.101 1.1 9.636-3.435 8.536-8.536z'
                    fill='#80b4fb'
                />
            </g>
            <g>
                <path
                    d='m363.517 308.273c-.97-4.498-.754-9.171.639-13.557 2.017-6.354 3.108-13.119 3.108-20.141v-78.225c0-6.959-1.07-13.668-3.052-19.973-1.373-4.367-1.583-9.016-.618-13.491l5.577-25.867c1.1-5.101-3.435-9.636-8.536-8.536l-25.148 5.422c-4.43.955-9.028.753-13.351-.586.117.457.239.912.38 1.363 1.982 6.305 3.052 13.014 3.052 19.973v78.225c0 7.022-1.091 13.788-3.108 20.141-1.392 4.386-1.608 9.059-.639 13.557l5.654 26.227c1.1 5.101-3.435 9.636-8.536 8.536l-26.227-5.654c-4.498-.97-9.171-.754-13.557.639-6.354 2.017-13.119 3.108-20.141 3.108h-184.782c-7.022 0-13.787-1.091-20.141-3.108-.415-.132-.835-.243-1.255-.354 1.059 4.016 1.163 8.23.285 12.302l-5.654 26.227c-1.1 5.101 3.435 9.636 8.536 8.536l26.227-5.654c4.498-.97 9.171-.754 13.557.639 6.354 2.017 13.119 3.108 20.141 3.108h184.783c7.022 0 13.787-1.091 20.141-3.108 4.386-1.392 9.059-1.608 13.557-.639l26.227 5.654c5.101 1.1 9.636-3.435 8.536-8.536z'
                    fill='#61a2f9'
                />
            </g>
            <g>
                <path
                    d='m292.513 281.343h-168.388c-48.739 0-88.25 39.511-88.25 88.25v43.479h344.888v-43.479c0-48.739-39.511-88.25-88.25-88.25z'
                    fill='#f9f5f5'
                />
            </g>
            <g>
                <path
                    d='m291.767 281.343h-37.255c49.151 0 88.996 39.845 88.996 88.996v42.734h37.255v-42.734c0-49.152-39.845-88.996-88.996-88.996z'
                    fill='#eedfda'
                />
            </g>
            <g>
                <path
                    d='m238.096 305.104h-59.553c-7.541 0-13.655-6.113-13.655-13.655v-48.462h86.863v48.462c0 7.541-6.114 13.655-13.655 13.655z'
                    fill='#ffcbbe'
                />
            </g>
            <g>
                <path
                    d='m229.353 242.987v48.346c0 7.605-6.165 13.77-13.77 13.77h22.398c7.605 0 13.77-6.165 13.77-13.77v-48.346z'
                    fill='#ffa68d'
                />
            </g>
            <g>
                <g>
                    <path
                        d='m242.148 95.721h-67.658c-17.673 0-32 14.327-32 32v46.67h131.658v-46.67c0-17.673-14.327-32-32-32z'
                        fill='#c56e37'
                    />
                </g>
                <g>
                    <path
                        d='m241.878 95.721h-16.232c16.627 0 30.106 13.479 30.106 30.106v48.564h18.397v-46.4c-.001-17.822-14.449-32.27-32.271-32.27z'
                        fill='#8f4e24'
                    />
                </g>
                <g>
                    <path
                        d='m149.584 193.192c3.921 12.056 7.944 24.395-2.339 27.739s-23.468-8.855-27.389-20.912c-3.921-12.056 1.238-24.541 11.521-27.885 10.283-3.343 14.286 9.002 18.207 21.058z'
                        fill='#ffcbbe'
                    />
                </g>
                <g>
                    <path
                        d='m267.054 193.192c-3.921 12.056-7.944 24.395 2.339 27.739s23.468-8.855 27.389-20.912c3.921-12.056-1.238-24.541-11.521-27.885-10.283-3.343-14.286 9.002-18.207 21.058z'
                        fill='#ffcbbe'
                    />
                </g>
                <g>
                    <path
                        d='m237.831 135.056h-59.024c-20.058 0-36.317 16.26-36.317 36.317v42.759c0 36.052 29.226 65.278 65.278 65.278h1.103c36.052 0 65.278-29.226 65.278-65.278v-42.759c-.001-20.057-16.261-36.317-36.318-36.317z'
                        fill='#ffcbbe'
                    />
                </g>
                <g>
                    <path
                        d='m248.147 136.627c1.018 3.363 1.571 6.928 1.571 10.623v41.901c0 36.356-29.473 65.829-65.829 65.829-11.904 0-23.06-3.176-32.696-8.703 11.352 19.791 32.674 33.133 57.126 33.133 36.356 0 65.829-29.473 65.829-65.829v-41.901c0-16.532-10.955-30.5-26.001-35.053z'
                        fill='#ffa68d'
                    />
                </g>
            </g>
            <g>
                <path
                    d='m267.054 193.192c-3.921 12.056-7.944 24.395 2.339 27.739s23.468-8.855 27.389-20.912c3.921-12.056-1.238-24.541-11.521-27.885-10.283-3.343-14.286 9.002-18.207 21.058z'
                    fill='#ffa68d'
                />
            </g>
            <g>
                <path
                    d='m467.664 198.011h-.621c-20.305 0-36.765-16.46-36.765-36.765v-66.175c0-3.651 2.96-6.61 6.61-6.61h60.931c3.651 0 6.61 2.96 6.61 6.61v66.175c0 20.304-16.46 36.765-36.765 36.765z'
                    fill='#f9f5f5'
                />
            </g>
            <g>
                <path
                    d='m497.763 88.46h-22.127c3.682 0 6.666 2.985 6.666 6.666v65.809c0 16.623-10.94 30.69-26.012 35.396 3.494 1.091 7.21 1.68 11.064 1.68 20.476 0 37.076-16.599 37.076-37.076v-65.809c-.001-3.681-2.985-6.666-6.667-6.666z'
                    fill='#eedfda'
                />
            </g>
            <g>
                <path
                    d='m430.278 124.45v36.485c0 20.476 16.599 37.076 37.076 37.076 20.476 0 37.076-16.599 37.076-37.076v-36.485z'
                    fill='#bed8fb'
                />
            </g>
            <g>
                <path
                    d='m482.302 124.45v36.485c0 16.623-10.94 30.69-26.012 35.396 3.494 1.091 7.21 1.68 11.064 1.68 20.476 0 37.076-16.599 37.076-37.076v-36.485z'
                    fill='#9dc6fb'
                />
            </g>
            <g>
                <path
                    d='m282.253 337.93h-147.791c-42.572 0-81.224 16.771-109.718 44.063-10.864 10.406-16.992 24.809-16.992 39.853v30.222c0 3.128 2.536 5.664 5.664 5.664h390.192c3.128 0 5.664-2.536 5.664-5.664v-29.931c0-14.994-6.097-29.344-16.889-39.754-28.533-27.523-67.354-44.453-110.13-44.453z'
                    fill='#80b4fb'
                />
            </g>
            <g>
                <path
                    d='m392.383 382.384c-28.534-27.524-67.355-44.453-110.13-44.453h-72.36c42.776 0 81.597 16.93 110.13 44.453 10.792 10.41 16.889 24.76 16.889 39.754v29.931c0 3.128-2.536 5.664-5.664 5.664h72.36c3.128 0 5.664-2.536 5.664-5.664v-29.931c0-14.994-6.097-29.345-16.889-39.754z'
                    fill='#61a2f9'
                />
            </g>
            <g>
                <ellipse
                    cx='177.469'
                    cy='187.473'
                    rx='9.063'
                    ry='9.063'
                    transform='matrix(.995 -.099 .099 .995 -17.61 18.4)'
                />
                <ellipse
                    cx='239.169'
                    cy='187.473'
                    rx='9.063'
                    ry='9.063'
                    transform='matrix(.995 -.099 .099 .995 -17.309 24.48)'
                />
                <path d='m220.761 219.565h-27.228c-4.177 0-7.563 3.386-7.563 7.563 0 4.178 3.386 7.563 7.563 7.563h27.228c4.177 0 7.563-3.386 7.563-7.563s-3.386-7.563-7.563-7.563z' />
                <path d='m497.763 80.897h-22.847v-19.066h29.513c4.177 0 7.563-3.386 7.563-7.563s-3.386-7.563-7.563-7.563h-388.735c-4.177 0-7.563 3.386-7.563 7.563s3.386 7.563 7.563 7.563h344.096v19.066h-22.846c-7.846 0-14.229 6.384-14.229 14.229v65.809c.172 7.345 1.582 14.977 6.472 23.129 4.08 6.708 9.88 12.258 16.78 16.041l-4.94 7.942c-7.367 11.844-8.052 26.943-1.788 39.405l20.542 40.866c4.969 9.886 2.816 22.071-5.234 29.654l-37.596 34.015v-145.836c0-11.648-9.476-21.124-21.124-21.124h-21.862c-.568-3.699-1.414-7.347-2.537-10.92-.976-3.105-1.129-6.435-.44-9.629l5.576-25.866c1.06-4.918-.43-9.977-3.987-13.535-3.557-3.557-8.618-5.052-13.537-3.988-7.839 1.033-27.03 7.836-35.021 4.903-2.983-.99-6.056-1.795-9.132-2.395-4.098-.792-8.071 1.88-8.869 5.98s1.879 8.071 5.979 8.869c2.444.476 4.886 1.116 7.258 1.903 5.726 1.9 11.89 2.229 17.827.948l24.571-5.297-5.452 25.291c-2.836 10.844 3.713 22.529 3.5 35.059v78.225c0 6.091-.927 12.097-2.754 17.853-.583 1.835-.988 3.715-1.25 5.613-17.042-15.086-39.432-24.26-63.929-24.26h-32.453v-7.433c10.52-10.16 18.046-23.466 21.001-38.541 10.93-3.668 20.215-14.856 23.66-25.447 5.204-16.002-2.142-32.787-16.374-37.416-.001-.001-.001-.001-.001-.001-1.552-.503-3.596-.949-5.888-.916v-36.034c0-21.964-17.869-39.834-39.834-39.834h-67.119c-20.008 0-36.613 14.831-39.412 34.075h-19.421c-10.698-1.087-21.507 5.392-33.182 4.277l-25.149-5.423c-4.918-1.061-9.979.432-13.535 3.989-3.557 3.558-5.047 8.617-3.987 13.535l5.576 25.867c.689 3.194.537 6.523-.44 9.629-1.123 3.572-1.969 7.22-2.537 10.919h-19.191v-106.898c0-8.986 7.311-16.298 16.297-16.298h41.124c4.177 0 7.563-3.386 7.563-7.563s-3.386-7.563-7.563-7.563h-41.124c-17.327 0-31.424 14.097-31.424 31.424v111.234c-5.066 3.862-8.355 9.94-8.355 16.788l.188 245.917c0 7.293 5.934 13.228 13.227 13.228h390.192c7.294 0 13.227-5.934 13.227-13.228l.116-79.683 47.798-43.245c.033-.03.066-.06.098-.091 12.941-12.132 16.415-31.675 8.449-47.525l-20.542-40.866c-3.914-7.787-3.486-17.221 1.117-24.622l6.819-10.962c2.175.327 4.399.499 6.664.499s0 0 0 0c16.153 0 30.329-8.624 38.167-21.509 2.881-4.252 6.666-14.529 6.472-23.129v-65.808c.001-7.846-6.383-14.23-14.229-14.23zm-95.939 125.254v159.52l-8.266 7.479c-1.725-1.558-3.474-3.082-5.254-4.56-.324-18.135-5.671-35.063-14.708-49.453-1.114-6.585-4.48-14.802-2.232-22.133 2.298-7.237 3.463-14.784 3.463-22.43v-74.421h21c3.307 0 5.997 2.691 5.997 5.998zm-229.373 71.448c10.65 5.977 22.902 9.374 35.868 9.374 12.967 0 25.218-3.397 35.868-9.374v13.734c0 3.422-2.785 6.207-6.207 6.207h-59.322c-3.423 0-6.207-2.785-6.207-6.207zm110.471-98.272c6.301 2.049 9.292 10.283 6.668 18.354-2.572 7.907-10.65 15.948-16.308 16.234-3.681.185-6.693 2.997-7.13 6.656-3.493 29.232-28.355 51.276-57.832 51.276s-54.34-22.044-57.832-51.276c-.437-3.66-3.449-6.471-7.13-6.656-5.659-.286-13.737-8.326-16.308-16.234-2.625-8.071.367-16.305 6.667-18.353.317-.103.566-.184.802-.184.493 0 .929.353 1.812 1.591 1.909 2.681 5.329 3.823 8.463 2.818 3.904-1.111 6.005-6.617 5.261-11.873 0-16.024 13.036-29.06 29.061-29.06h58.41c16.024 0 29.061 13.036 29.061 29.06-.171 4.026-.471 9.402 5.261 11.873 3.134 1.005 6.555-.137 8.463-2.818 1.303-1.831 1.633-1.724 2.611-1.408zm-132.869-51.335c0-13.624 11.084-24.707 24.707-24.707h67.118c13.623 0 24.707 11.083 24.707 24.707v10.441c-7.775-6.804-17.942-10.939-29.061-10.939h-58.41c-11.119 0-21.286 4.135-29.061 10.939zm-70.496 13.305c5.936 1.278 12.1.95 17.828-.949 5.972-1.982 12.211-2.988 18.543-2.988h18.999v26.665c-2.29-.034-4.337.412-5.889.918-14.232 4.629-21.578 21.413-16.374 37.416 3.444 10.593 12.728 21.78 23.66 25.447 2.955 15.075 10.481 28.381 21.001 38.541v7.433h-32.453c-24.496 0-46.887 9.174-63.929 24.261-.262-1.899-.668-3.779-1.25-5.613-1.827-5.755-2.754-11.763-2.754-17.853v-78.225c-.641-10.818 6.302-22.612 3.5-35.059l-5.452-25.291zm-64.43 64.854c0-3.307 2.69-5.997 5.998-5.997h20.686v74.421c0 7.646 1.165 15.193 3.463 22.43 2.286 4.612-1.189 17.139-2.233 22.133-9.048 14.409-14.397 31.361-14.708 49.522-3.022 2.512-5.965 5.136-8.822 7.872-1.546 1.481-3.008 3.038-4.385 4.661v-175.042zm386.581 244.018h-386.393v-28.323c0-12.932 5.344-25.466 14.66-34.391 20.909-20.028 46.889-33.552 75.13-39.113 4.098-.807 6.767-4.783 5.96-8.881-.807-4.1-4.785-6.771-8.882-5.96-20.597 4.054-40.085 11.977-57.591 23.257 6.486-38.457 40.005-67.852 80.278-67.852h32.453v2.427c0 11.764 9.57 21.334 21.334 21.334h59.322c11.764 0 21.333-9.57 21.333-21.334v-2.427h32.453c40.239 0 73.733 29.344 80.26 67.753-26.572-17.104-57.535-26.292-89.775-26.292h-143.33c-4.177 0-7.563 3.386-7.563 7.563 0 4.178 3.386 7.563 7.563 7.563h143.333c34.329 0 67.068 11.455 93.659 32.52.07.058.144.112.216.168 3.799 3.021 7.472 6.238 11.005 9.646 9.264 8.935 14.576 21.44 14.576 34.31v28.032zm95.158-354.145v20.863h-59.025v-20.863zm-2.323 76.388c-2.926 8.628-15.692 18.665-27.19 18.035-16.273 0-29.512-13.239-29.512-29.512v-28.922h59.025v28.922c-.428 4.049.2 4.675-2.323 11.477z' />
            </g>
        </g>
    </svg>
);

const outpatientIcon = (
    <svg
        className='outpatientIcon'
        height='512'
        viewBox='0 0 512 512'
        width='512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g
            id='Fill_out_line'
            data-name='Fill out line'
        >
            <path
                d='m24 496v-8l24-168 112-16h192l112 16 24 168v8z'
                fill='#d4e4f0'
            />
            <g fill='#529ddf'>
                <path d='m352 304v88l-96 96-96-96v-88z' />
                <path d='m256 336-48-48v-16h-16l-32 32 64 64z' />
                <path d='m256 336 48-48v-16h16l32 32-64 64z' />
            </g>
            <path
                d='m280 360-16 16h-16l-16-16 24-24z'
                fill='#44a6f9'
            />
            <path
                d='m281.431 445.725-25.431 42.275-25.324-42.706 17.324-69.294h16z'
                fill='#44a6f9'
            />
            <path
                d='m136 304v56h24l-8 48 104 80-96-184z'
                fill='#c1d7e6'
            />
            <path
                d='m376 304v56h-24l8 48-104 80 96-184z'
                fill='#c1d7e6'
            />
            <circle
                cx='416'
                cy='400'
                fill='#529ddf'
                r='32'
            />
            <path
                d='m304 80v208l-48 48-48-48v-40h-40l-16-56-32-16 40-96z'
                fill='#fdc5ca'
            />
            <path
                d='m328 32v118.06a81.93423 81.93423 0 0 1 -24 57.94 218.0205 218.0205 0 0 1 -36.31982-28.44 215.53421 215.53421 0 0 1 -17.86011-19.51 216.88606 216.88606 0 0 1 -17.26-24.61 218.18483 218.18483 0 0 1 -18.35007-38.37l-6.21-17.07h-64a24.00619 24.00619 0 0 1 -24-24v-24z'
                fill='#ba8b5d'
            />
            <path
                d='m216 144 9.37259-9.37259a22.6274 22.6274 0 0 1 16-6.62741 22.62739 22.62739 0 0 1 22.62741 22.62739v5.54761a65.47772 65.47772 0 0 1 -10.997 36.32049 16.85279 16.85279 0 0 1 -14.02233 7.50451 16.85278 16.85278 0 0 1 -11.91671-4.93606l-11.06396-11.06394z'
                fill='#fdc5ca'
            />
            <path d='m184 120h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z' />
            <path d='m89.13184 322.20508-2.26368-15.83887-40 5.71436a7.99948 7.99948 0 0 0 -6.78808 6.78808l-24 168 15.83984 2.2627 23.15137-162.06055z' />
            <path d='m471.91992 318.86865a8 8 0 0 0 -6.78808-6.78808l-24-3.42871-2.26368 15.83886 18.06055 2.58057 23.15137 162.06006 15.83984-2.2627z' />
            <path d='m424 360.80493v-48.80493a48.054 48.054 0 0 0 -48-48h-64v-52.80292a89.2893 89.2893 0 0 0 24-61.138v-118.05908a8.00008 8.00008 0 0 0 -8-8h-208a8.00008 8.00008 0 0 0 -8 8v24a32.03635 32.03635 0 0 0 32 32h3.99976l-35.38453 84.92285a7.99994 7.99994 0 0 0 3.80665 10.23242l28.85253 14.42627 15.03321 52.61621a7.99983 7.99983 0 0 0 7.69238 5.80225h32v8h-48a48.054 48.054 0 0 0 -48 48v72.51782a64.08151 64.08151 0 0 0 -56 63.48218v40a8.00008 8.00008 0 0 0 8 8h24v-16h-16v-32a48 48 0 0 1 96 0v32h-16v16h24a8.00008 8.00008 0 0 0 8-8v-40a64.08151 64.08151 0 0 0 -56-63.48218v-72.51782a32.03635 32.03635 0 0 1 32-32h20.686l-16.45777 16.45776-21.36011 3.05152a8.00024 8.00024 0 0 0 -6.86812 7.91943v52.57129a8.00008 8.00008 0 0 0 8 8h14.55664l-2.44824 14.68457 15.7832 2.63086 4-24a8.00034 8.00034 0 0 0 -7.8916-9.31543h-16v-37.63281l11.52612-1.64685 76.60474 146.82544-35.25293-27.11756-9.75586 12.68164 64 49.231a8.00006 8.00006 0 0 0 9.75586 0l104-80a8.00088 8.00088 0 0 0 3.01367-7.65576l-6.44824-38.6851h14.55664a8.00008 8.00008 0 0 0 8-8v-43.34741l6.86816.9812 2.26368-15.83887-37.36036-5.33716-16.45748-16.45776h36.686a32.03635 32.03635 0 0 1 32 32v48.80493a40 40 0 1 0 16 0zm-296-304.80493v-16h192v110.05908a73.38843 73.38843 0 0 1 -17.31836 47.56055 211.26732 211.26732 0 0 1 -32.21094-26.55011 73.60823 73.60823 0 0 0 1.5293-14.89472v-5.54736a30.65073 30.65073 0 0 0 -38.41895-29.62671 211.84525 211.84525 0 0 1 -11.85449-26.66235l-6.208-17.07227a7.99974 7.99974 0 0 0 -7.51856-5.26611h-64a16.01833 16.01833 0 0 1 -16-16zm46.03418 184-14.3418-50.19775a8.00248 8.00248 0 0 0 -4.11426-4.95752l-25.32128-12.66065 35.07666-84.18408h37.063l4.293 11.80664a227.9444 227.9444 0 0 0 13.0149 29.176l-9.3606 9.36017 11.3125 11.31446 9.374-9.37305a14.62689 14.62689 0 0 1 24.9697 10.34322v5.54736a57.29153 57.29153 0 0 1 -9.65332 31.88282 8.85294 8.85294 0 0 1 -13.626 1.34961l-11.06347-11.064-11.31446 11.31348 11.06446 11.06445a24.85317 24.85317 0 0 0 38.25195-3.7876 73.81151 73.81151 0 0 0 5.1543-9.06726 227.3475 227.3475 0 0 0 31.18654 24.48551v72.33471l-40 40-40-40v-33.373l13.65723-13.65674a8.00018 8.00018 0 0 0 -11.31446-11.31348l-13.65625 13.6567zm55.62305 133.65674 2.34277-2.34274 7.14062 7.14051-10.13012 40.52034-37.8005-72.45092 27.13281 27.13281a8.00063 8.00063 0 0 0 11.31446 0zm24.58886 10.34326h3.50782l14.08642 56.34436-15.84033 30.36047-15.84033-30.36047zm28.74366 34.97485-10.13037-40.52038 7.14062-7.14047 2.34277 2.34278a8.00063 8.00063 0 0 0 11.31446 0l27.13277-27.13285zm-22.30375-50.97485h-9.372l-8-8 12.686-12.686 12.686 12.686zm-65.37256-88h4.68656v8a8.00035 8.00035 0 0 0 2.34277 5.65674l42.34323 42.34326-20.686 20.68652-52.68652-52.68652zm172.68656 72h-16a8.00034 8.00034 0 0 0 -7.8916 9.31543l7.21191 43.26807-71.45117 54.9624 76.60449-146.82569 11.52637 1.64673zm-27.31348-48-52.68652 52.68652-20.686-20.68652 42.34327-42.34326a8.00035 8.00035 0 0 0 2.34273-5.65674v-8h4.68652zm75.31348 120a23.99787 23.99787 0 0 1 -8-46.62378v8.78178a16 16 0 1 0 16 0v-8.78174a23.99787 23.99787 0 0 1 -8 46.62374z' />
            <path d='m384 448h16v40h-16z' />
            <path d='m112 448h16v40h-16z' />
        </g>
    </svg>
);

const medicationIcon = (
    <svg
        version='1.1'
        className='medicationIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace='preserve'
    >
        <polygon
            style={{ fill: '#E3F2FF' }}
            points='25.451,235.988 25.451,402.98 231.1,402.98 231.11,402.99 325.436,333.473 325.436,235.988'
        />
        <path
            style={{ fill: '#FE73B1' }}
            d='M476.668,326.983c19.243,33.343,8.012,76.195-25.619,95.615l-58.297,33.658l-69.996-121.234
	        c77.812-44.926,53.441-30.854,58.297-33.658C414.531,282.036,457.339,293.505,476.668,326.983z'
        />
        <path
            style={{ fill: '#FEC459' }}
            d='M322.756,335.023l69.996,121.234l-62.937,36.338c-33.478,19.329-76.286,7.86-95.615-25.619
	        c-19.456-33.792-7.607-76.423,25.619-95.615L322.756,335.023z'
        />
        <path
            style={{ fill: '#ED5151' }}
            d='M265.439,135.993l51.997,69.326c5.19,6.93,8,15.349,8,23.999v6.67H25.451v-6.67
	        c0-8.65,2.81-17.069,8-23.999l51.997-69.326V95.995h179.991V135.993z'
        />
        <path
            style={{ fill: '#57555C' }}
            d='M285.438,29.998v45.998c0,11.049-8.95,19.999-19.999,19.999H85.448
	        c-11.049,0-19.999-8.95-19.999-19.999V29.998c0-11.049,8.95-19.999,19.999-19.999h179.991
	        C276.488,9.999,285.438,18.949,285.438,29.998z'
        />
        <path
            style={{ fill: '#ED5151' }}
            d='M231.11,402.99l-0.01-0.01H25.451v19.999c0,22.089,17.909,39.998,39.998,39.998H232.05l0.01-0.01
	        L231.11,402.99z'
        />
        <path
            d='M125.696,145.993c5.52,0,9.999-4.48,9.999-9.999c0-5.52-4.48-9.999-9.999-9.999c-5.52,0-9.999,4.48-9.999,9.999
	        C115.696,141.513,120.176,145.993,125.696,145.993z'
        />
        <path
            d='M215.691,312.984h-29.998v-29.998c0-5.522-4.478-9.999-9.999-9.999s-9.999,4.478-9.999,9.999v29.998h-29.998
	        c-5.522,0-9.999,4.478-9.999,10c0,5.522,4.478,9.999,9.999,9.999h29.998v29.998c0,5.522,4.478,9.999,9.999,9.999
	        s9.999-4.478,9.999-9.999v-29.998h29.998c5.522,0,9.999-4.478,9.999-9.999C225.691,317.462,221.214,312.984,215.691,312.984z'
        />
        <path
            d='M376.303,292.705l-40.618,23.45v-86.836c0-10.735-3.55-21.388-10-29.998l-49.997-66.661v-28.386
	        c11.638-4.128,19.999-15.242,19.999-28.279V29.998C295.687,13.457,282.23,0,265.689,0H85.698C69.157,0,55.699,13.457,55.699,29.998
	        v45.998c0,13.035,8.361,24.151,19.999,28.279v28.386l-50.001,66.665c-6.446,8.606-9.995,19.258-9.995,29.993v193.66
	        c0,27.569,22.429,49.997,49.997,49.997h160.702c22.421,37.583,70.767,50.16,108.664,28.279L456.3,431.258
	        c37.955-21.918,51.494-70.779,29.277-109.274C463.473,283.698,414.596,270.594,376.303,292.705z M225.219,392.98H35.7V245.988
	        h279.986V327.7l-60.619,35.002C242.428,370.003,232.212,380.396,225.219,392.98z M75.698,29.998c0-5.514,4.486-9.999,9.999-9.999
	        h179.991c5.514,0,10,4.486,10,9.999v45.998c0,5.514-4.486,9.999-10,9.999H85.698c-5.514,0-9.999-4.486-9.999-9.999
	        C75.698,75.996,75.698,29.998,75.698,29.998z M93.697,141.993c1.298-1.73,2-3.836,2-6v-29.998h159.992v19.999h-89.995
	        c-5.522,0-9.999,4.478-9.999,9.999c0,5.522,4.478,9.999,9.999,9.999h94.995l48.993,65.322c3.202,4.275,5.191,9.39,5.792,14.674
	        H35.913c0.6-5.284,2.589-10.398,5.788-14.669L93.697,141.993z M35.7,422.979v-10.099h181.675
	        c-3.171,12.965-3.15,26.813,0.481,40.098H65.699C49.158,452.977,35.7,439.52,35.7,422.979z M325.066,483.935
	        c-28.697,16.571-65.367,6.771-81.949-21.946c-16.661-28.994-6.564-65.498,21.952-81.969l54.277-31.338l59.997,103.915
	        L325.066,483.935z M446.3,413.939l-49.637,28.659l-59.998-103.917l49.638-28.657c28.716-16.578,65.373-6.761,81.955,21.957
	        C484.913,360.844,474.785,397.49,446.3,413.939z'
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
);

const procedureIcon = (
    <svg
        className='procedureIcon'
        enableBackground='new 0 0 64 64'
        height='512'
        viewBox='0 0 64 64'
        width='512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle
            cx='51'
            cy='51'
            fill='#ff826e'
            r='11'
        />
        <path
            d='m30 51v8h-28v-16h14 14z'
            fill='#e6e9ed'
        />
        <g fill='#fcd770'>
            <circle
                cx='24'
                cy='51'
                r='2'
            />
            <circle
                cx='16'
                cy='51'
                r='2'
            />
            <circle
                cx='8'
                cy='51'
                r='2'
            />
        </g>
        <path
            d='m10 2-8 8v12 14h14 14v-14-2-18z'
            fill='#e6e9ed'
        />
        <path
            d='m6 26h20v6h-20z'
            fill='#4fc1e9'
        />
        <path
            d='m26 6v8h-20v-4h4v-4z'
            fill='#ffeaa7'
        />
        <path
            d='m10 6v4h-4-4l8-8z'
            fill='#fcd770'
        />
        <path
            d='m36 12v8 10h18v-18z'
            fill='#f0d0b4'
        />
        <path
            d='m54.76 3.24c.79-.79 1.87-1.24 3-1.24 1.17 0 2.23.48 3 1.24.76.77 1.24 1.83 1.24 3 0 1.13-.45 2.21-1.24 3l-1.76 1.76-3-3-3-3z'
            fill='#aab2bd'
        />
        <path
            d='m50 20-5.74 1.91c-.17.06-.35.09-.54.09-.95 0-1.72-.77-1.72-1.72 0-.19.03-.37.09-.54l1.91-5.74 3 3z'
            fill='#aab2bd'
        />
        <path
            d='m59 11-5 5-4 4-3-3 9-9z'
            fill='#ff826e'
        />
        <path
            d='m56 8-9 9-3-3 2-2 7-7z'
            fill='#b4dd7f'
        />
        <path d='m51 39c-6.28 0-11.438 4.85-11.949 11h-8.051v-8h-14v-5h14v-16h4v10h20v-14.586l6.465-6.465c.99-.99 1.535-2.306 1.535-3.707 0-2.89-2.352-5.242-5.242-5.242-1.4 0-2.717.545-3.707 1.535l-8.465 8.465h-10.586v8h-4v-18h-21.414l-8.586 8.586v27.414h14v5h-14v18h30v-8h8.051c.511 6.15 5.669 11 11.949 11 6.617 0 12-5.383 12-12s-5.383-12-12-12zm-5.586-25 7.586-7.586 1.586 1.586-7.586 7.586zm-.977 1.851 3.712 3.712-4.198 1.399c-.462.156-.951-.209-.951-.683 0-.076.013-.156.036-.228zm5.563 2.735-1.586-1.586 7.586-7.586 1.586 1.586zm7.758-15.586c1.788 0 3.242 1.454 3.242 3.242 0 .866-.337 1.681-.949 2.293l-1.051 1.051-4.586-4.586 1.051-1.051c.612-.612 1.427-.949 2.293-.949zm-20.758 10h6.586l-.46.46-1.988 5.962c-.091.278-.138.566-.138.857 0 1.5 1.221 2.721 2.721 2.721.291 0 .579-.047.86-.14l5.959-1.986 2.46-2.46v10.586h-16zm-32.586-4 4.586-4.586v4.586zm2.586 2h4v-4h14v6h-18zm-4 0h2v4h22v-10h-16v-2h18v32h-26zm26 47h-26v-14h26zm22 3c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10z' />
        <path d='m49 55.586-3.293-3.293-1.414 1.414 4.707 4.707 9.707-9.707-1.414-1.414z' />
        <path d='m8 54c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z' />
        <path d='m16 54c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z' />
        <path d='m24 54c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z' />
        <path d='m39 25h12v2h-12z' />
        <path d='m5 17h2v2h-2z' />
        <path d='m9 17h18v2h-18z' />
        <path d='m5 21h22v2h-22z' />
        <path d='m5 33h22v-8h-22zm2-6h18v4h-18z' />
    </svg>
);

const inboundIcon = (
    <svg
        className='inboundIcon'
        enableBackground='new 0 0 512 512'
        height='512'
        viewBox='0 0 512 512'
        width='512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g>
            <path
                d='m396.134 402.054c-26.6 43.143-77.602 64.869-127.074 53.848-55.606-12.388-116.07-46.096-168.095-98.121-52.032-52.032-85.74-112.497-98.127-168.105-11.02-49.472 10.704-100.474 53.848-127.074 9.671-5.963 22.172-4.5 30.206 3.534l59.669 59.669c11.193 11.193 9.005 29.902-4.47 38.209l-24.382 15.033c-10.233 6.309-14.399 19.103-9.806 30.212 9.969 24.109 27.982 57.476 60.222 88.494 28.838 27.744 58.895 43.832 81.454 53.137 11.074 4.568 23.829.354 30.116-9.843l15.038-24.391c8.308-13.475 27.016-15.663 38.209-4.47l59.66 59.66c8.034 8.034 9.496 20.535 3.534 30.206z'
                fill='#b5adb6'
            />
            <path
                d='m396.134 402.054.002-.003c5.963-9.671 4.501-22.172-3.534-30.206l-59.66-59.66c-11.193-11.193-29.902-9.005-38.209 4.47l-3.26 5.287-.005.016 94.344 94.344c3.744-4.447 7.206-9.194 10.322-14.248z'
                fill='#918291'
            />
            <path
                d='m136.791 167.281 5.3-3.268c13.474-8.308 15.663-27.016 4.47-38.209l-59.669-59.669c-8.034-8.034-20.535-9.496-30.206-3.534-5.054 3.116-9.802 6.579-14.251 10.324l94.354 94.354z'
                fill='#918291'
            />
            <path
                d='m512 125.731c-45.37-34.64-110.49-31.23-151.97 10.25-17.12 17.12-27.76 38.28-31.91 60.41-.52 2.8.4 5.67 2.41 7.68l16.31 16.31c9.12 9.12 2.66 24.7-10.23 24.7h-118.44c-12.62 0-23.07-9.32-24.82-21.45-.17-1.18-.26-2.39-.26-3.62v-118.45c0-12.89 15.59-19.34 24.7-10.23l14.88 14.88c3.41 3.41 8.96 3.4 12.32-.05l1.68-1.71c56.02-56.02 140.6-66.06 206.87-30.13.04.02.09.04.13.06 14.43 7.84 27.99 17.86 40.2 30.07 6.7 6.71 12.75 13.82 18.13 21.28z'
                fill='#8795de'
            />
            <g>
                <path
                    d='m512 125.731c-45.37-34.64-110.49-31.23-151.97 10.25-17.12 17.12-27.76 38.28-31.91 60.41-.52 2.8.4 5.67 2.41 7.68l16.31 16.31c9.12 9.12 2.66 24.7-10.23 24.7h-118.44c-12.62 0-23.07-9.32-24.82-21.45 14.95-1.03 28.68 2.55 44.14.28 26.85-3.95 49.81-24.23 59.56-44.74 6.11-12.85 2.14-18.63 6.63-30.33 26.65-69.37 122.25-88.69 149.86-74.52.04.02.09.04.13.06 14.43 7.84 27.99 17.86 40.2 30.07 6.7 6.71 12.75 13.82 18.13 21.28z'
                    fill='#6c7fd8'
                />
            </g>
        </g>
    </svg>
);

const outboundIcon = (
    <svg
        className='outboundIcon'
        enableBackground='new 0 0 512 512'
        height='512'
        viewBox='0 0 512 512'
        width='512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g>
            <g>
                <path
                    d='m398.54 419.605c-26.761 43.405-78.073 65.263-127.845 54.175-55.944-12.463-116.775-46.376-169.116-98.717-52.348-52.348-86.26-113.18-98.723-169.126-11.088-49.772 10.769-101.085 54.174-127.846 9.73-5.999 22.307-4.528 30.39 3.555l60.031 60.031c11.261 11.261 9.059 30.083-4.497 38.441l-24.53 15.124c-10.295 6.347-14.487 19.219-9.866 30.395 10.029 24.255 28.152 57.825 60.588 89.032 29.013 27.913 59.253 44.098 81.948 53.46 11.142 4.596 23.973.356 30.298-9.903l15.13-24.54c8.358-13.556 27.18-15.758 38.441-4.497l60.022 60.022c8.083 8.083 9.554 20.66 3.555 30.39z'
                    fill='#b5adb6'
                />
                <g fill='#918291'>
                    <path d='m398.539 419.605.002-.003c5.999-9.73 4.528-22.307-3.555-30.39l-60.022-60.022c-11.261-11.261-30.084-9.059-38.441 4.497l-3.285 5.328v.008l94.917 94.917c3.767-4.475 7.25-9.251 10.384-14.335z' />
                    <path d='m137.62 183.405.002.001 5.332-3.288c13.556-8.358 15.758-27.18 4.497-38.441l-60.031-60.031c-8.082-8.083-20.659-9.554-30.389-3.555-5.085 3.135-9.862 6.619-14.337 10.387z' />
                </g>
            </g>
            <path
                d='m504.611 123.917-84.26-84.26c-9.169-9.169-24.847-2.675-24.847 10.292v21.168c0 4.85-3.951 8.795-8.801 8.73-.803-.011-1.607-.016-2.412-.016-97.121 0-175.853 78.733-175.853 175.853 0 9.538.757 18.902 2.232 28.033 7.636-56.92 56.386-100.817 115.401-100.817 24.367 0 46.982 7.486 65.678 20.276 2.364 1.617 3.754 4.317 3.754 7.181v23.208c0 12.967 15.678 19.461 24.847 10.292l84.26-84.26c9.853-9.854 9.853-25.828.001-35.68z'
                fill='#7acaa6'
            />
            <g>
                <path
                    d='m504.611 123.917-84.26-84.26c-8.271-8.272-21.835-3.794-24.412 6.681l77.579 77.579c9.852 9.852 9.852 25.826 0 35.679l-77.579 77.579c2.577 10.475 16.141 14.952 24.412 6.681l84.26-84.26c9.852-9.853 9.852-25.827 0-35.679z'
                    fill='#57be92'
                />
            </g>
        </g>
    </svg>
);

const callIcon = (
    <svg
        version='1.1'
        className='callIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 384 384'
        style={{ enableBackground: 'new 0 0 384 384' }}
        xmlSpace='preserve'
    >
        <g>
            <g>
                <path
                    d='M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.906-3.719-23.323-0.833-30.438,6.417l-43.177,32.594
			        c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448
			        c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.812C13.823,0,0,13.823,0,30.812
			        C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z
			         M362.667,353.188c0,5.229-4.25,9.479-9.479,9.479c-182.99,0-331.854-148.865-331.854-331.854c0-5.229,4.25-9.479,9.479-9.479
			        h70.521c5.229,0,9.479,4.25,9.479,9.479c0,25.802,4.052,51.125,11.979,75.115c1.104,3.542,0.208,7.208-3.375,10.938L82.75,165.427
			        c-2.458,3.26-2.844,7.625-1,11.26c29.927,58.823,66.292,95.188,125.531,125.542c3.604,1.885,8.021,1.49,11.292-0.979
			        l49.677-37.635c2.51-2.51,6.271-3.406,9.667-2.25c24.156,7.979,49.479,12.021,75.271,12.021c5.229,0,9.479,4.25,9.479,9.479
			        V353.188z'
                />
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
);

const gymIcon = (
    <svg
        version='1.1'
        className='gymIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 481.089 481.089'
        style={{ enableBackground: 'new 0 0 481.089 481.089' }}
        xmlSpace='preserve'
    >
        <g>
            <path
                style={{ fill: '#EAE8CA' }}
                d='M212.144,248.289l48-10.4v-24.8c-8-2.4-16-4-24-4v-34.4l0,0c-4,1.6-7.2,2.4-11.2,3.2h-0.8
		        c-1.6,0-4,0.8-5.6,0.8h-0.8c-4,0-7.2,0-11.2,0h-0.8c-1.6,0-4-0.8-5.6-0.8h-0.8c-4-0.8-7.2-2.4-11.2-3.2l0,0v33.6c-8,0-16,1.6-24,4
		        v24.8L212.144,248.289z'
            />
            <path
                style={{ fill: '#EAE8CA' }}
                d='M200.144,177.889c1.6,0,4,0.8,5.6,0.8h0.8c4,0,7.2,0,11.2,0h0.8c1.6,0,4-0.8,5.6-0.8h0.8
		        c4-0.8,7.2-2.4,11.2-3.2c3.2-1.6,7.2-3.2,10.4-5.6c28.8-20,45.6-36.8,45.6-72v-4l-56-28.8l-104,18.4c0,1.6,0,4,0,5.6v8
		        c0,4,0,8,0.8,12c0,1.6,0.8,3.2,0.8,4.8s0.8,4,1.6,5.6s1.6,3.2,1.6,5.6c0.8,1.6,0.8,2.4,1.6,4s1.6,4,3.2,5.6
		        c0.8,0.8,0.8,2.4,1.6,3.2c1.6,1.6,2.4,4,4,5.6c0.8,0.8,1.6,1.6,1.6,2.4c1.6,1.6,3.2,4,5.6,5.6c0.8,0.8,1.6,1.6,1.6,1.6
		        c2.4,1.6,4,4,6.4,5.6c0.8,0,0.8,0.8,1.6,0.8c2.4,2.4,5.6,4,8.8,6.4c1.6,0.8,3.2,2.4,4,3.2c3.2,2.4,6.4,4,10.4,5.6s7.2,2.4,11.2,3.2
		        C199.344,177.889,200.144,177.889,200.144,177.889z'
            />
        </g>
        <path
            style={{ fill: '#6A9FD3' }}
            d='M292.144,221.089c-9.6-4.8-20-8-32-9.6v1.6v24.8l-48,10.4l-48-10.4v-24.8v-1.6
	        c-12,1.6-22.4,5.6-32,9.6v3.2v70.4c0,9.6,10.4,17.6,24,17.6h112c13.6,0,24-8,24-17.6v-6.4v-56V221.089z'
        />
        <g>
            <path
                style={{ fill: '#EAE8CA' }}
                d='M132.144,296.289v-1.6v-70.4c-29.6,28.8-48,79.2-48,120c0,19.2,0.8,60,13.6,72h26.4l-2.4-12.8
		        C118.544,380.289,121.744,317.089,132.144,296.289z'
            />
            <path
                style={{ fill: '#EAE8CA' }}
                d='M379.344,136.289h0.8H379.344l-4.8,74.4c-0.8,12-11.2,21.6-24,21.6h-58.4v56l92.8-20
		        c11.2-2.4,19.2-12,19.2-23.2v-124.8h-24L379.344,136.289z'
            />
        </g>
        <g>
            <polygon
                style={{ fill: '#6A9FD3' }}
                points='316.144,112.289 316.144,160.289 348.144,160.289 348.144,136.289 348.144,112.289 	'
            />
            <rect
                x='420.144'
                y='112.289'
                style={{ fill: '#6A9FD3' }}
                width='32'
                height='48'
            />
        </g>
        <path
            style={{ fill: '#E8B408' }}
            d='M161.744,25.889c-4,3.2-8,7.2-12,12c0,0.8-0.8,0.8-0.8,1.6c-1.6,1.6-2.4,3.2-4,4.8
	        c-0.8,0.8-0.8,1.6-1.6,2.4c-0.8,1.6-1.6,3.2-2.4,4.8c-0.8,0.8-0.8,1.6-1.6,3.2s-0.8,2.4-1.6,4c0,0.8-0.8,1.6-0.8,2.4v0.8
	        c-0.8,1.6-0.8,3.2-1.6,4c0,0.8-0.8,1.6-0.8,2.4c-0.8,1.6-0.8,3.2-0.8,5.6c0,0.8,0,1.6-0.8,2.4c0,1.6-0.8,4-0.8,5.6v0.8l104-18.4
	        l56,28v-4c0-45.6-38.4-83.2-85.6-80c-2.4,0-4.8,0.8-8,0.8c-0.8,0-1.6,0-2.4,0.8c-1.6,0-3.2,0.8-4.8,0.8c-0.8,0-2.4,0.8-3.2,0.8
	        c-1.6,0-2.4,0.8-4,1.6c-0.8,0.8-2.4,0.8-3.2,1.6c-0.8,0.8-2.4,0.8-3.2,1.6s-2.4,0.8-3.2,1.6s-1.6,0.8-3.2,1.6
	        c-1.6,0.8-2.4,1.6-3.2,2.4c-0.8,0.8-1.6,0.8-2.4,1.6C164.144,23.489,163.344,25.089,161.744,25.889L161.744,25.889L161.744,25.889z'
        />
        <polygon
            style={{ fill: '#6A9FD3' }}
            points='28.144,392.289 28.144,440.289 60.144,440.289 60.144,416.289 60.144,392.289 '
        />
        <path
            style={{ fill: '#EAE8CA' }}
            d='M148.144,312.289c10.4,25.6,10.4,54.4,0,80h16v8h112l-3.2-10.4c-8-24-7.2-50.4,2.4-74.4l0.8-3.2h-8
	        h-112H148.144z'
        />
        <path
            style={{ fill: '#E8B408' }}
            d='M163.344,157.089c-2.4-1.6-4.8-4-6.4-5.6c-0.8-0.8-1.6-1.6-1.6-1.6c-1.6-1.6-4-3.2-5.6-5.6
	        c-0.8-0.8-1.6-1.6-1.6-2.4c-1.6-1.6-3.2-3.2-4-5.6c-0.8-0.8-1.6-2.4-1.6-3.2c-0.8-1.6-2.4-3.2-3.2-5.6c-0.8-1.6-0.8-2.4-1.6-4
	        s-1.6-3.2-1.6-5.6c-0.8-1.6-0.8-4-1.6-5.6c0-1.6-0.8-3.2-0.8-4.8c-1.6-2.4-1.6-6.4-1.6-11.2v-8c0-1.6,0-4,0-5.6l0,0l0,0
	        c0-0.8,0-2.4,0-3.2c0-0.8,0-1.6,0-2.4s0-0.8,0-1.6l0,0c0-1.6,0.8-2.4,0.8-4c0-0.8,0.8-1.6,0.8-2.4l0,0c0,0,0,0,0-0.8
	        c0.8-1.6,0.8-3.2,1.6-5.6c0-0.8,0.8-1.6,0.8-2.4c0.8-1.6,1.6-3.2,2.4-5.6c0,0,0-0.8,0.8-0.8l0,0c0,0,0-0.8,0.8-0.8
	        c0.8-1.6,1.6-2.4,2.4-4l0.8-0.8c0.8-1.6,1.6-3.2,3.2-4.8c0-0.8,0.8-0.8,0.8-1.6c0.8-1.6,1.6-3.2,3.2-4.8c0.8-0.8,0.8-0.8,1.6-1.6
	        c0.8-1.6,2.4-2.4,3.2-4l0.8-0.8c0.8-0.8,2.4-2.4,3.2-3.2s0.8-0.8,1.6-1.6c-4-0.8-8-1.6-12.8-1.6c-31.2,0-56,24.8-56,56v120
	        c32,0,60.8-13.6,81.6-35.2l0,0c-3.2-2.4-5.6-4-8.8-6.4C164.144,157.889,164.144,157.889,163.344,157.089z'
        />
        <path
            style={{ fill: '#6A9FD3' }}
            d='M108.144,480.289L108.144,480.289c0-25.6,8.8-60,24.8-80h143.2l7.2,8.8c16,20,24.8,45.6,24.8,71.2
	        l0,0H108.144z'
        />
        <path
            style={{ fill: '#222426' }}
            d='M452.144,104.289h-32c-4.8,0-8,3.2-8,8v8c0-4.8-3.2-8-8-8h-24c-4,0-8,3.2-8,7.2l-0.8,8.8h-15.2v-16
	        c0-4.8-3.2-8-8-8h-32c-4.8,0-8,3.2-8,8v48c0,4.8,3.2,8,8,8h32c4.8,0,8-3.2,8-8v-16h14.4l-4,65.6c-0.8,8-8,14.4-16,14.4h-50.4v-3.2
	        c0-3.2-1.6-5.6-4.8-7.2c-10.4-4.8-21.6-8.8-34.4-10.4c-1.6,0-2.4,0-4,0c-4.8-1.6-8.8-2.4-13.6-3.2v-21.6c2.4-1.6,4.8-2.4,7.2-4
	        c27.2-19.2,48.8-37.6,48.8-78.4v-4v-4c0-24-10.4-48-28-64c-2.4-2.4-4.8-4.8-8-6.4c-9.6-7.2-20-12-31.2-14.4
	        c-7.2-3.2-16.8-4-25.6-3.2c-3.2,0-5.6,0.8-8,0.8c-0.8,0-2.4,0.8-3.2,0.8c-1.6,0-3.2,0.8-4.8,0.8s-3.2,0.8-4,1.6
	        c-0.8,0-2.4,0.8-3.2,0.8c-1.6,0.8-3.2,0.8-4.8,1.6c-0.8,0-1.6,0.8-3.2,0.8c-1.6,0.8-3.2,1.6-4.8,2.4c-0.8,0.8-1.6,0.8-2.4,1.6
	        c-1.6,0.8-3.2,1.6-4.8,3.2c-0.8,0.8-1.6,0.8-1.6,1.6c-0.8,0.8-1.6,0.8-1.6,1.6c-40-7.2-75.2,24-75.2,63.2v120c0,4.8,3.2,8,8,8
	        c31.2,0,60-12,82.4-32.8c1.6,1.6,4,2.4,5.6,3.2v21.6c-4.8,0.8-8.8,1.6-13.6,3.2c-1.6-0.8-2.4-0.8-4,0c-12,2.4-24,5.6-34.4,10.4
	        c-2.4,1.6-4.8,4-4.8,7.2l0,0c-28,29.6-48,79.2-48,123.2c0,21.6,0.8,47.2,7.2,64h-15.2v-16c0-4.8-3.2-8-8-8h-32c-4.8,0-8,3.2-8,8v48
	        c0,4.8,3.2,8,8,8h32c4.8,0,8-3.2,8-8v-16h29.6h16c-8.8,17.6-13.6,36.8-13.6,56h16c0-13.6,3.2-27.2,8-40l0,0c0,4.8,3.2,8,8,8h32
	        c4.8,0,8-3.2,8-8v-32h100l4.8,5.6c15.2,18.4,23.2,41.6,23.2,65.6h16c0-28-9.6-54.4-26.4-76l-6.4-8l-3.2-9.6
	        c-7.2-22.4-6.4-46.4,2.4-68.8l0.8-0.8c10.4-4,17.6-12.8,17.6-22.4l0,0l86.4-18.4c14.4-3.2,25.6-16,25.6-31.2v-84.8c0,4.8,3.2,8,8,8
	        h32c4.8,0,8-3.2,8-8v-48C460.144,107.489,456.944,104.289,452.144,104.289z M340.144,152.289h-16v-32h16V152.289z M52.144,432.289
	        h-16v-32h16V432.289z M241.744,161.889c-3.2,1.6-5.6,3.2-8.8,4.8l0,0c-3.2,1.6-6.4,2.4-9.6,3.2h-0.8c-1.6,0-3.2,0.8-4.8,0.8h-0.8
	        c-3.2,0-6.4,0-8.8,0h-0.8c-1.6,0-3.2-0.8-4.8-0.8h-0.8c-3.2-0.8-6.4-1.6-9.6-3.2l0,0c-3.2-1.6-6.4-3.2-8.8-4.8
	        c-1.6-0.8-3.2-2.4-4.8-3.2c-2.4-1.6-5.6-4-8-5.6c-0.8-0.8-1.6-1.6-2.4-2.4c-1.6-1.6-3.2-3.2-4.8-4s-2.4-2.4-4-3.2
	        c-0.8-0.8-2.4-2.4-3.2-3.2c-1.6-1.6-2.4-3.2-4-4.8c-0.8-0.8-1.6-1.6-2.4-2.4c-0.8-1.6-2.4-3.2-3.2-4.8c-0.8-0.8-0.8-1.6-1.6-2.4
	        c-0.8-1.6-1.6-4-2.4-5.6c0-0.8-0.8-1.6-0.8-2.4c-0.8-2.4-0.8-4-1.6-6.4c0-0.8-0.8-1.6-0.8-2.4c0.8-5.6,0.8-8.8,0.8-12.8v-7.2
	        l94.4-16.8l48.8,24.8C284.144,126.689,270.544,141.889,241.744,161.889z M173.744,26.689c0.8-0.8,2.4-0.8,3.2-1.6s1.6-0.8,2.4-1.6
	        c0.8-0.8,1.6-0.8,3.2-1.6c0.8-0.8,1.6-0.8,3.2-1.6c0.8,0,1.6-0.8,3.2-0.8c0.8,0,2.4-0.8,3.2-0.8s1.6-0.8,2.4-0.8
	        c1.6,0,2.4-0.8,4-0.8c0.8,0,1.6,0,2.4-0.8c2.4,0,4-0.8,6.4-0.8c20-1.6,39.2,5.6,54.4,19.2c1.6,1.6,3.2,3.2,4.8,4.8
	        c0.8,0.8,0.8,0.8,1.6,1.6c0.8,1.6,1.6,2.4,3.2,4c0.8,0.8,0.8,1.6,1.6,2.4c0.8,1.6,1.6,2.4,2.4,4c0.8,0.8,0.8,1.6,1.6,2.4
	        c0.8,1.6,1.6,2.4,1.6,4c0,0.8,0.8,1.6,0.8,2.4c0.8,1.6,1.6,3.2,1.6,4.8c0,0.8,0,0.8,0.8,1.6c0.8,2.4,1.6,4,1.6,6.4
	        c0,0.8,0,1.6,0,1.6c0,1.6,0.8,2.4,0.8,4l-44-21.6c-1.6-0.8-2.4-0.8-4-0.8c-0.8,0-0.8,0-1.6,0l-92.8,16.8c0-0.8,0.8-2.4,0.8-3.2
	        c0-1.6,0.8-2.4,0.8-4c0-0.8,0.8-1.6,0.8-3.2c0.8-1.6,1.6-3.2,1.6-4.8c0-0.8,0.8-0.8,0.8-1.6c0.8-2.4,2.4-4,3.2-6.4c0,0,0,0,0-0.8
	        c1.6-2.4,2.4-4,4-5.6l0,0c3.2-4,7.2-8,11.2-11.2l0,0c1.6-1.6,4-3.2,6.4-4C172.944,27.489,173.744,27.489,173.744,26.689z
	         M100.144,80.289c0-24.8,19.2-45.6,43.2-48c-0.8,1.6-2.4,3.2-3.2,4l-0.8,0.8c-1.6,1.6-2.4,4-3.2,5.6c0,0,0,0.8-0.8,0.8
	        c-0.8,3.2-1.6,4.8-3.2,7.2v0.8l0,0c-0.8,2.4-1.6,4-2.4,6.4l0,0v0.8c-0.8,1.6-1.6,4-1.6,5.6c0,0.8,0,1.6-0.8,2.4
	        c0,1.6-0.8,3.2-0.8,4.8c0,1.6,0,2.4-0.8,4c0,1.6,0,2.4-0.8,4c0,2.4,0,5.6,0,8v8c0,3.2,0,6.4,0.8,9.6c0,0.8,0,1.6,0,3.2
	        c0,2.4,0.8,5.6,1.6,8c0,0.8,0.8,2.4,0.8,3.2c0.8,1.6,0.8,3.2,1.6,4.8c0,0.8,0.8,2.4,1.6,3.2c0.8,2.4,2.4,4.8,3.2,6.4
	        c0,0.8,0.8,1.6,1.6,2.4c6.4,11.2,16,20,26.4,28.8c-16.8,15.2-38.4,24-60.8,26.4C100.144,192.289,100.144,80.289,100.144,80.289z
	         M188.144,216.289c4.8,0,8-3.2,8-8v-23.2c0.8,0,0.8,0,1.6,0c2.4,0.8,4,0.8,6.4,0.8c0.8,0,0.8,0,1.6,0c2.4,0,4,0.8,6.4,0.8
	        s4,0,6.4-0.8c0.8,0,0.8,0,1.6,0c2.4,0,4-0.8,6.4-0.8c0.8,0,0.8,0,1.6,0v23.2c0,4.8,3.2,8,8,8c5.6,0,10.4,0.8,16,2.4v12.8l-40,8.8
	        l-40-8.8v-12.8C177.744,217.089,182.544,216.289,188.144,216.289z M141.744,317.089c8,21.6,8,44.8,0.8,67.2h-10.4
	        c-1.6,0-2.4,0-3.2,0.8c-0.8-21.6,1.6-52,6.4-71.2C136.944,315.489,139.344,316.289,141.744,317.089z M92.144,344.289
	        c0-33.6,12.8-71.2,32-98.4v48.8c-10.4,24-14.4,86.4-10.4,110.4l0.8,3.2h-13.6C96.944,401.889,92.144,385.089,92.144,344.289z
	         M156.144,432.289h-16v-32h8h8V432.289z M172.144,392.289c0-4.8-3.2-8-8-8h-4.8c6.4-20.8,6.4-43.2,0-64h105.6
	        c-7.2,23.2-7.2,48.8,0.8,72l0,0H172.144z M284.144,294.689c0,4-7.2,9.6-16,9.6h-112c-8.8,0-16-4.8-16-9.6v-68.8
	        c4.8-2.4,10.4-4,16-5.6v16.8c0,4,2.4,7.2,6.4,8l48,10.4c0.8,0,2.4,0,3.2,0l48-10.4c4-0.8,6.4-4,6.4-8v-16.8c5.6,1.6,11.2,3.2,16,5.6
	        v6.4v56L284.144,294.689L284.144,294.689z M396.144,245.089c0,7.2-5.6,14.4-12.8,16l-83.2,17.6v-38.4h50.4c16.8,0,30.4-12.8,32-29.6
	        l4.8-82.4h8.8V245.089z M444.144,152.289h-16v-32h16V152.289z'
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
);

const transportationIcon = (
    <svg
        version='1.1'
        className='transportationIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace='preserve'
    >
        <path
            style={{ fill: '#FFDC64' }}
            d='M296.825,56.889h-81.65c-9.269,0-17.18,6.702-18.705,15.846l-6.841,41.043H322.37l-6.841-41.043
	        C314.005,63.591,306.094,56.889,296.825,56.889z'
        />
        <g>
            <rect
                x='18.963'
                y='189.63'
                style={{ fill: '#E1A546' }}
                width='47.407'
                height='18.963'
            />
            <rect
                x='445.63'
                y='189.63'
                style={{ fill: '#E1A546' }}
                width='47.407'
                height='18.963'
            />
        </g>
        <g>
            <path
                style={{ fill: '#FFC850' }}
                d='M397.262,104.296H114.738c-11.961,0-22.644,7.482-26.732,18.724l-31.117,85.573v28.444h398.222
		        v-28.444l-31.117-85.573C419.906,111.778,409.222,104.296,397.262,104.296L397.262,104.296z'
            />
            <path
                style={{ fill: '#FFC850' }}
                d='M18.963,170.667h9.481c10.473,0,18.963,8.489,18.963,18.963l0,0
		        c0,10.473-8.489,18.963-18.963,18.963h-9.481C8.489,208.593,0,200.103,0,189.63l0,0C0,179.156,8.489,170.667,18.963,170.667z'
            />
            <path
                style={{ fill: '#FFC850' }}
                d='M483.556,170.667h9.481c10.473,0,18.963,8.489,18.963,18.963l0,0
		        c0,10.473-8.489,18.963-18.963,18.963h-9.481c-10.474,0-18.963-8.489-18.963-18.963l0,0
		        C464.593,179.156,473.082,170.667,483.556,170.667z'
            />
        </g>
        <path
            style={{ fill: '#707487' }}
            d='M397.262,123.259c3.973,0,7.553,2.508,8.91,6.241l29.976,82.433v6.14H75.852v-6.14l29.976-82.433
	        c1.358-3.733,4.937-6.241,8.91-6.241H397.262'
        />
        <g>
            <path
                style={{ fill: '#5B5D6E' }}
                d='M284.444,123.259H114.738c-3.973,0-7.553,2.508-8.91,6.241l-29.976,82.433v6.14H189.63
		        L284.444,123.259z'
            />
            <path
                style={{ fill: '#5B5D6E' }}
                d='M18.963,369.778v75.852c0,5.236,4.245,9.481,9.481,9.481h28.444c5.236,0,9.481-4.245,9.481-9.481
		        v-75.852H18.963z'
            />
        </g>
        <path
            style={{ fill: '#464655' }}
            d='M18.963,407.462c7.948,6.016,17.73,9.723,28.444,9.723H66.37v-47.407H18.963V407.462z'
        />
        <path
            style={{ fill: '#5B5D6E' }}
            d='M493.037,369.778v75.852c0,5.236-4.245,9.481-9.481,9.481h-28.444c-5.236,0-9.481-4.245-9.481-9.481
	        v-75.852H493.037z'
        />
        <path
            style={{ fill: '#464655' }}
            d='M493.037,407.462c-7.948,6.016-17.73,9.723-28.444,9.723H445.63v-47.407h47.407V407.462z'
        />
        <path
            style={{ fill: '#FFDC64' }}
            d='M484.725,245.612l-29.614-37.019H56.889l-29.615,37.019c-5.38,6.724-8.311,15.079-8.311,23.692
	        v100.474c0,15.71,12.735,28.444,28.444,28.444h417.185c15.71,0,28.444-12.735,28.444-28.444V269.304
	        C493.037,260.691,490.105,252.335,484.725,245.612z'
        />
        <path
            style={{ fill: '#FFC850' }}
            d='M94.815,331.852c-5.236,0-9.481-4.245-9.481-9.482v-53.067c0-8.613,2.111-16.967,5.984-23.692
	        l21.323-37.019H56.889l-29.615,37.019c-5.38,6.725-8.311,15.08-8.311,23.692v100.474c0,15.71,12.735,28.444,28.444,28.444h417.185
	        c15.71,0,28.444-12.735,28.444-28.444v-37.926H94.815z'
        />
        <path
            style={{ fill: '#5B5D6E' }}
            d='M159.106,312.889h193.786c4.351,0,8.143-2.961,9.198-7.182l4.741-18.963
	        c1.496-5.984-3.031-11.781-9.198-11.781H154.366c-6.169,0-10.694,5.797-9.198,11.781l4.741,18.963
	        C150.963,309.927,154.756,312.889,159.106,312.889z'
        />
        <g>
            <circle
                style={{ fill: '#FFFFFF' }}
                cx='85.333'
                cy='355.556'
                r='14.222'
            />
            <circle
                style={{ fill: '#FFFFFF' }}
                cx='426.667'
                cy='355.556'
                r='14.222'
            />
            <circle
                style={{ fill: '#FFFFFF' }}
                cx='80.593'
                cy='289.185'
                r='28.444'
            />
            <circle
                style={{ fill: '#FFFFFF' }}
                cx='431.407'
                cy='289.185'
                r='28.444'
            />
        </g>
        <path
            style={{ fill: '#464655' }}
            d='M360.296,360.296H151.704c-5.236,0-9.481,4.245-9.481,9.481v28.444h227.556v-28.444
	        C369.778,364.54,365.532,360.296,360.296,360.296z'
        />
        <path
            style={{ fill: '#5B5D6E' }}
            d='M284.444,94.815h-56.889c-5.236,0-9.481-4.245-9.481-9.481l0,0c0-5.236,4.245-9.481,9.481-9.481
	        h56.889c5.236,0,9.481,4.245,9.481,9.481l0,0C293.926,90.569,289.681,94.815,284.444,94.815z'
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
);

const dentalIcon = (
    <svg
        version='1.1'
        className='dentalIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 496 496'
        style={{ enableBackground: 'new 0 0 496 496' }}
        xmlSpace='preserve'
    >
        <g>
            <path
                style={{ fill: '#F0BC5E' }}
                d='M0,372L0,372c35.344,0,64-28.656,64-64l0,0l0,0c0,35.344,28.656,64,64,64l0,0l0,0
		        c-35.344,0-64,28.656-64,64l0,0l0,0C64,400.656,35.344,372,0,372L0,372z'
            />
            <path
                style={{ fill: '#F0BC5E' }}
                d='M368,164L368,164c35.344,0,64-28.656,64-64l0,0l0,0c0,35.344,28.656,64,64,64l0,0l0,0
		        c-35.344,0-64,28.656-64,64l0,0l0,0C432,192.656,403.344,164,368,164L368,164z'
            />
        </g>
        <path d='M112,158.68V156H96v2.68c0,4.584,0.12,9.168,0.352,13.728l15.984-0.816C112.12,167.296,112,163,112,158.68z' />
        <path
            d='M97.712,188.904c4.576,40.296,18.624,79.68,40.616,113.88l13.456-8.656c-20.672-32.152-33.864-69.168-38.176-107.04
	        L97.712,188.904z'
        />
        <path
            d='M248,92c-16.816,0-33.024-4.944-46.88-14.296l-8.952,13.264C208.68,102.112,227.984,108,248,108s39.32-5.888,55.84-17.04
	        l-8.952-13.264C281.032,87.056,264.816,92,248,92z'
        />
        <path
            d='M72,308H56c0,30.872-25.128,56-56,56v16c30.872,0,56,25.128,56,56h16c0-30.872,25.128-56,56-56v-16
	        C97.128,364,72,338.872,72,308z M64,403.16C57.12,389.8,46.2,378.88,32.84,372c13.36-6.88,24.28-17.8,31.16-31.16
	        c6.88,13.36,17.8,24.28,31.16,31.16C81.8,378.88,70.88,389.8,64,403.16z'
        />
        <path
            d='M440,100h-15.32c-15.152-37.688-52.24-64-94.264-64c-19.84,0-38.496,5.368-53.952,15.512
	        c-17.112,11.264-39.808,11.264-56.928,0C204.088,41.368,185.432,36,165.584,36C109.568,36,64,81.568,64,137.584v21.096
	        c0,57.36,16.4,113.168,47.416,161.416c16.688,25.96,28.944,54.304,36.432,84.24l8.704,34.832
	        C159.608,451.44,170.576,460,183.216,460c13.72,0,25.16-9.848,27.184-23.416l17.944-119.664c1.48-9.8,9.744-16.92,19.656-16.92
	        c9.912,0,18.176,7.12,19.648,16.92l17.944,119.664C287.624,450.152,299.064,460,312.784,460c12.64,0,23.608-8.56,26.664-20.832
	        l8.712-34.832c7.488-29.944,19.752-58.288,36.44-84.24c18.232-28.368,31.568-60.048,39.368-92.928
	        C423.96,227.448,424,227.72,424,228h16c0-30.872,25.128-56,56-56v-16C465.128,156,440,130.872,440,100z M371.136,311.44
	        c-17.64,27.44-30.584,57.392-38.496,89.024l-8.72,34.832c-1.272,5.128-5.856,8.704-11.136,8.704c-5.736,0-10.512-4.12-11.36-9.792
	        L283.48,314.544C280.824,296.84,265.896,284,248,284s-32.824,12.84-35.48,30.544l-17.944,119.664
	        c-0.84,5.672-5.624,9.792-11.36,9.792c-5.28,0-9.864-3.576-11.152-8.704l-8.712-34.832c-7.904-31.64-20.856-61.592-38.496-89.024
	        C95.512,265.784,80,212.96,80,158.68v-21.096C80,90.392,118.392,52,165.584,52c16.712,0,32.328,4.456,45.16,12.888
	        C221.952,72.256,234.496,76,248,76s26.048-3.744,37.248-11.112C298.088,56.456,313.704,52,330.416,52
	        c42.208,0,78.624,31.448,84.624,72.512l0.336,5.208C405.456,145.472,387.952,156,368,156v16c18.784,0,35.4,9.328,45.56,23.56
	        C408.16,236.584,393.504,276.64,371.136,311.44z M432,195.16c-6.88-13.36-17.8-24.28-31.16-31.16c13.36-6.88,24.28-17.8,31.16-31.16
	        c6.88,13.36,17.8,24.28,31.16,31.16C449.8,170.88,438.88,181.8,432,195.16z'
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
);

const visionIcon = (
    <svg
        version='1.1'
        className='visionIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace='preserve'
    >
        <path
            style={{ fill: '#303C42' }}
            d='M504.813,254.448L475.271,121.49c-4.75-21.292-23.292-36.156-45.083-36.156
	        c-25.458,0-46.188,20.719-46.188,46.177v7.156c0,5.896,4.771,10.667,10.667,10.667c5.896,0,10.667-4.771,10.667-10.667v-7.156
	        c0-13.698,11.146-24.844,24.854-24.844c11.729,0,21.708,8.01,24.25,19.458l29.542,132.948c3.667,16.521,5.833,33.375,6.479,50.26
	        h-0.87c-5.441-53.75-50.428-96-105.589-96c-48.228,0-88.613,32.385-101.758,76.398c-6.527-6.882-15.129-12.398-26.242-12.398
	        s-19.715,5.517-26.242,12.398c-13.145-44.013-53.53-76.398-101.758-76.398c-55.16,0-100.147,42.25-105.589,96h-0.87
	        c0.646-16.885,2.813-33.74,6.479-50.26l29.542-132.938c2.542-11.458,12.521-19.469,24.25-19.469
	        c13.708,0,24.854,11.146,24.854,24.844v7.156c0,5.896,4.771,10.667,10.667,10.667S128,144.563,128,138.667v-7.156
	        c0-25.458-20.729-46.177-46.188-46.177c-21.792,0-40.333,14.865-45.083,36.167L7.188,254.448C2.417,275.969,0,298.021,0,320
	        c0,5.896,4.771,10.667,10.667,10.667h11.745c5.441,53.75,50.428,96,105.589,96c57.904,0,104.951-46.451,106.398-104.012
	        c2.143-5.964,10.667-23.988,21.602-23.988c10.654,0,19.07,17.02,21.599,23.956c1.43,57.576,48.487,104.044,106.401,104.044
	        c55.16,0,100.147-42.25,105.589-96h11.745c5.896,0,10.667-4.771,10.667-10.667C512,298.021,509.583,275.969,504.813,254.448z'
        />
        <g>
            <circle
                style={{ fill: '#BBDEFB' }}
                cx='128'
                cy='320'
                r='85.333'
            />
            <circle
                style={{ fill: '#BBDEFB' }}
                cx='384'
                cy='320'
                r='85.333'
            />
        </g>
        <linearGradient
            id='SVGID_1_'
            gradientUnits='userSpaceOnUse'
            x1='-44.3294'
            y1='633.1749'
            x2='-37.0769'
            y2='629.7938'
            gradientTransform='matrix(21.3333 0 0 -21.3333 996.3334 13791.667)'
        >
            <stop
                offset='0'
                style={{ stopColor: '#FFFFFF', stopOpacity: '0.5' }}
            />
            <stop
                offset='1'
                style={{ stopColor: '#FFFFFF', stopOpacity: '0' }}
            />
        </linearGradient>
        <circle
            style={{ fill: 'url(#SVGID_1_)' }}
            cx='128'
            cy='320'
            r='85.333'
        />
        <linearGradient
            id='SVGID_2_'
            gradientUnits='userSpaceOnUse'
            x1='-32.3294'
            y1='633.1749'
            x2='-25.0769'
            y2='629.7938'
            gradientTransform='matrix(21.3333 0 0 -21.3333 996.3334 13791.667)'
        >
            <stop
                offset='0'
                style={{ stopColor: '#FFFFFF', stopOpacity: '0.5' }}
            />
            <stop
                offset='1'
                style={{ stopColor: '#FFFFFF', stopOpacity: '0' }}
            />
        </linearGradient>
        <circle
            style={{ fill: 'url(#SVGID_2_)' }}
            cx='384'
            cy='320'
            r='85.333'
        />
        <linearGradient
            id='SVGID_3_'
            gradientUnits='userSpaceOnUse'
            x1='-45.4693'
            y1='639.8659'
            x2='-23.5158'
            y2='629.6301'
            gradientTransform='matrix(21.3333 0 0 -21.3333 996.3334 13791.667)'
        >
            <stop
                offset='0'
                style={{ stopColor: '#FFFFFF', stopOpacity: '0.2' }}
            />
            <stop
                offset='1'
                style={{ stopColor: '#FFFFFF', stopOpacity: '0' }}
            />
        </linearGradient>
        <path
            style={{ fill: 'url(#SVGID_3_)' }}
            d='M504.813,254.448L475.271,121.49c-4.75-21.292-23.292-36.156-45.083-36.156
	        c-25.458,0-46.188,20.719-46.188,46.177v7.156c0,5.896,4.771,10.667,10.667,10.667c5.896,0,10.667-4.771,10.667-10.667v-7.156
	        c0-13.698,11.146-24.844,24.854-24.844c11.729,0,21.708,8.01,24.25,19.458l29.542,132.948c3.667,16.521,5.833,33.375,6.479,50.26
	        h-0.87c-5.441-53.75-50.428-96-105.589-96c-48.228,0-88.613,32.385-101.758,76.398c-6.527-6.882-15.129-12.398-26.242-12.398
	        s-19.715,5.517-26.242,12.398c-13.145-44.013-53.53-76.398-101.758-76.398c-55.16,0-100.147,42.25-105.589,96h-0.87
	        c0.646-16.885,2.813-33.74,6.479-50.26l29.542-132.938c2.542-11.458,12.521-19.469,24.25-19.469
	        c13.708,0,24.854,11.146,24.854,24.844v7.156c0,5.896,4.771,10.667,10.667,10.667S128,144.563,128,138.667v-7.156
	        c0-25.458-20.729-46.177-46.188-46.177c-21.792,0-40.333,14.865-45.083,36.167L7.188,254.448C2.417,275.969,0,298.021,0,320
	        c0,5.896,4.771,10.667,10.667,10.667h11.745c5.441,53.75,50.428,96,105.589,96c57.904,0,104.951-46.451,106.398-104.012
	        c2.143-5.964,10.667-23.988,21.602-23.988c10.654,0,19.07,17.02,21.599,23.956c1.43,57.576,48.487,104.044,106.401,104.044
	        c55.16,0,100.147-42.25,105.589-96h11.745c5.896,0,10.667-4.771,10.667-10.667C512,298.021,509.583,275.969,504.813,254.448z'
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
);

const mealIcon = (
    <svg
        className='mealIcon'
        enableBackground='new 0 0 512 512'
        viewBox='0 0 512 512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g id='Filled_outline'>
            <path
                d='m174.4 270.8c-8.5 3.3-18.1-.3-22.3-8.4l-78-150.2c-9.1-17.8-2.2-39.5 15.6-48.6 1.1-.5 2.1-1 3.2-1.5 20.1-8.1 42.2 3.7 47.8 24.1l.1.3 44.3 163.1c2.3 8.7-2.3 17.9-10.7 21.2z'
                fill='#f98500'
            />
            <path
                d='m170.2 195.1-22.1 8.7c-4.1 1.5-8.7-.5-10.4-4.6-1.6-4.1.4-8.8 4.5-10.4l23.7-9.3z'
                fill='#fa6d00'
            />
            <path
                d='m178.8 226.4-19 7.1c-4.1 1.4-8.6-.5-10.4-4.6-1.6-4.1.4-8.8 4.6-10.4l20.6-7.7z'
                fill='#fa6d00'
            />
            <path
                d='m268.5 123.9c-6.7-4.6-10.1-12.7-8.6-20.8 3.7-18.6-8.3-36.7-27-40.5-.2 0-.5-.1-.7-.1-7.7-1.3-14.1-6.8-16.5-14.3-.6-1.8-1.3-3.6-2.1-5.3-8.5-17-29.1-23.9-46.1-15.4-16.1 8-23.3 27.1-16.5 43.7 3.5 8.6 5.2 16.4-.7 24.7-11 15.5-7.3 37 8.2 47.9.1.1.3.2.4.3 6.7 4.7 9.9 12.9 8.3 20.9-3.6 18.6 8.6 36.7 27.3 40.3 16.8 3.2 33.3-6.3 39-22.4 17 8.5 37.6 1.5 46.1-15.4 7.6-15.3 2.9-33.8-11.1-43.6z'
                fill='#598c44'
            />
            <path
                d='m346.5 151.4c-4.5-6.8-4.6-15.6-.2-22.5 10.5-15.8 6.1-37.2-9.7-47.7-.2-.1-.4-.3-.6-.4-9.8-6.2-9.1-15-9.9-25.1-1.4-18.9-18-33.1-36.9-31.7-17.9 1.4-31.8 16.3-31.8 34.3 0 9.3-1.4 17.1-9.9 22.6-16 10.2-20.7 31.5-10.4 47.5.1.1.2.3.3.4 4.4 6.9 4.4 15.7-.2 22.5-10.3 15.9-5.8 37.2 10.1 47.6 14.3 9.3 33.3 6.7 44.5-6.1 12.6 14.2 34.3 15.6 48.5 3.1 12.8-11.2 15.4-30.2 6.2-44.5z'
                fill='#5f9548'
            />
            <path
                d='m400 248-96-32 52.9-158.6c6.4-19.1 25.9-33.9 46.2-33.4 12.6.3 24.4 2.7 34.3 10.7 16 12.8 22.3 34.2 15.8 53.6z'
                fill='#ffb531'
            />
            <path
                d='m336 168v288h-240v-288l24 16 24-16 24 16 24-16 24 16 24-16 24 16 24-16 24 16z'
                fill='#ffb531'
            />
            <path
                d='m336 234.3v221.7h-240v-48.5c88.1-29.6 175.4-83.5 240-173.2z'
                fill='#fcac1f'
            />
            <path
                d='m432 168v288h-96v-288l24 16 24-16 24 16z'
                fill='#f98500'
            />
            <circle
                cx='97.5'
                cy='424'
                fill='#f35244'
                r='64'
            />
            <path
                d='m232 320 8 16c-9.9 9.9-13.9 24.3-10.5 38l2.5 10h-32v-12.2c0-21.9 12.4-42 32-51.8z'
                fill='#5f9548'
            />
            <path
                d='m185.1 488c-10.1 0-19.1-6.6-22-16.3l-18-60.1c-5-16.7 6-35.6 24.5-35.6 9 0 17.3 4.7 21.9 12.4l16.5 27.6v49.1c0 12.6-10.3 22.9-22.9 22.9z'
                fill='#fa9f0c'
            />
            <path
                d='m246.9 488c10.1 0 19.1-6.6 22-16.3l18-60.1c5.1-16.9-6.1-35.6-24.5-35.6-9 0-17.3 4.7-21.9 12.4l-16.5 27.6v49.1c0 12.6 10.3 22.9 22.9 22.9z'
                fill='#fa9f0c'
            />
            <path
                d='m216 376c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24-13.3 0-24-10.7-24-24v-64c0-13.3 10.7-24 24-24z'
                fill='#ffb531'
            />
            <g id='Outline'>
                <path d='m442.4 28.5c-14.8-11.9-35.1-15.5-54.4-9.9-18.8 5.5-32.9 18.8-38.7 36.3l-32.3 97-3.8-5.6-13.4 8.9v-32.3l22.2-14.8-8.9-13.3-13.4 8.9v-36.7h-16v36.6l-13.3-8.9-8.9 13.3 22.2 14.8v32.3l-13.3-8.9-8.9 13.3 12.3 8.2-9.9 6.6-19.6-13c-.9-.6-1.8-1-2.8-1.2.6-1.5 1.4-3 2.3-4.4 6.2-9.5 6.2-21.7.1-31.3-5.6-8.5-5.4-21.2.4-29.7 2.5-3.6 12.7-10.9 15.4-14.5 5.3-7 5.9-15 6.5-22 .4-5.5.8-10.3 3.2-14 7.7-12.3 24-16 36.3-8.3 2.6 1.6 4.8 3.7 6.7 6 4.3 5.4 4.7 10.8 5.2 18.1.2 2.5.4 5.2.7 8l15.9-2c-.3-2.4-.5-4.8-.6-7.1-.6-8.7-1.3-17.6-8.6-26.9-14.5-18.4-41.1-21.5-59.5-7.1-3.8 3-7.1 6.6-9.7 10.7-4.4 7-5 14.6-5.6 21.2-.1 1.5-.2 2.9-.4 4.3-4.9-3.3-10.5-5.6-16.4-6.7-4.8-.8-8.8-4.2-10.3-8.8-3.5-10.9-11.1-19.9-21.3-25.1-10-5.3-21.7-6.3-32.5-2.8-15.9 5.3-27.5 20.2-28.9 37.3-.5 6.5 1.1 12.2 2.7 17.3-7.5-12.3-20.6-20.1-35-21l.3-35.5-16-.1-.2 23.1-9.6-24.6-14.6 6.1 9.6 24.6-15.8-16.8-11.6 10.9 24.3 26c-13.2 13.6-16.3 34-7.5 50.8l16.6 32 14.2-7.4-16.6-32c-7.1-13.7-1.8-30.6 11.9-37.7s30.6-1.8 37.7 11.9c.9 1.8 1.6 3.6 2.2 5.6l.3 1-25.8 10.1 5.8 14.9 24.2-9.4v.1c-1.5 5.7-1.9 11.6-.9 17.5l-17.4 6.8 5.8 14.9 17.2-6.7c4 6.7 10.9 12.9 10.9 12.9l-22.3 8.7 2.6 6.5-13.3 8.9-19.6-13c-3.7-2.5-8.6-1.5-11.1 2.2-.9 1.3-1.3 2.9-1.3 4.4v168h16v-153.1l11.6 7.7c2.7 1.8 6.2 1.8 8.9 0l19.6-13 19.6 13c2.7 1.8 6.2 1.8 8.9 0l19.6-13 19.6 13c2.7 1.8 6.2 1.8 8.9 0l19.6-13 19.6 13c2.7 1.8 6.2 1.8 8.9 0l19.6-13 19.6 13c2.7 1.8 6.2 1.8 8.9 0l11.6-7.7v265.1h-32v16h136c4.4 0 8-3.6 8-8v-288c0-2.4-1.1-4.6-2.9-6.1l23.7-71c6.9-22.6-.5-47.5-19-62.4zm-211.7 104.9c.7 1.1 1.2 2.3 1.5 3.6l-5.5 8.1-12.2-30 10.7-15.8c-2.8 11.5-1 24.3 5.5 34.1zm-55.8 36.5c2.1-8.5.4-17.4-4.5-24.6-4.7-6.8-12.2-11.5-16-18.9-2-3.9-2.8-8.4-2.3-12.8 1.2-9.8 8.6-18 9.7-27.8.8-7.2-2.1-14.2-3.6-21.3-3.5-15.7 6.4-31.6 23.3-32.4 8.2-.3 16 3.2 21.2 9.5 4.6 5.7 6.7 13.2 11.3 19 3.4 4.3 8 7.4 13.2 8.9 5.1 1.5 11.1 1.7 14.5 5.8-5.9 4.2-10.7 9.7-14 16.2l-11.4-7.6-9 13-13.8-33.7-14.7 6 13.7 33.8-15.6-3-3.2 15.6 25.7 5.8 12.5 29.4-15.6-3-1.9 9.4c-.1.1-15.4 9.7-19.5 12.7zm27.8-4.4 16.5 3.4 1.1 2.7-4.3 2.8zm103.2 4.8 6.2-4.2-2.3 6.8zm38.1 12.6 11.6 7.7c2.7 1.8 6.2 1.8 8.9 0l11.6-7.7v221.7l-32 32v-253.7zm80 0v253.7l-32-32v-221.7l11.6 7.7c2.7 1.8 6.2 1.8 8.9 0zm-40 236.4 28.7 28.7h-57.4zm61.6-333.5-27.2 81.6-10.4 6.9-19.6-13c-2.7-1.8-6.2-1.8-8.9 0l-19.6 13s-20-13.3-20.2-13.4c-2.6-1.4-5.8-1.2-8.2.4l-1.2.8 34.1-102.2c4.2-12.5 14.4-21.9 28.1-26 14.2-4.2 29.1-1.6 39.9 7 13.3 10.8 18.6 28.7 13.2 44.9z' />
                <path
                    d='m375.7 76h48.7v16h-48.7z'
                    transform='matrix(.986 -.164 .164 .986 -8.368 66.914)'
                />
                <path
                    d='m359.7 124h48.7v16h-48.7z'
                    transform='matrix(.986 -.164 .164 .986 -16.478 64.937)'
                />
                <path d='m262.5 368c-8.8-.1-17.3 3.4-23.5 9.7-.1-.1-.2-.2-.3-.4l-1.3-5.3c0-.1 0-.1-.1-.2-3.1-10.9 3.1-24.7 8.5-30.1 2.4-2.4 3-6.2 1.5-9.2l-8-16c-2-4-6.8-5.6-10.7-3.6-22.4 11.1-36.5 34-36.4 58.9v4.3c-1.9-1.4-4-2.7-6.1-3.9-15.5-8.3-35.6-3.1-44.8 11.5-5.3 8.5-6.7 20-3.7 30.1l10.4 34.7c-13.8 27.7-47.4 39-75.1 25.3-27.4-13.6-38.8-46.7-25.6-74.3.2-.4.4-.8.6-1.2l.3 27.2 16-.2-.5-33.3 31.9 1.5.8-16-27.8-1.3c8.3-5.1 17.9-7.9 27.6-8.2 11.6-.3 23 3 32.6 9.5l8.9-13.3c-18-12.1-40.5-15.4-61.2-9.1l3.4-8-14.7-6.3-11 25.6c-.8.6-1.7 1.3-2.5 2l-24.4-24.4-11.3 11.3 24.6 24.6c-.5.7-1 1.4-1.5 2.1l-26.2 11.2 6.3 14.7 9.2-4c-11.1 38.2 10.9 78.1 49.1 89.2 25.2 7.3 52.4.3 71-18.3 1.9-1.9 3.7-4 5.4-6.1l1.6 5.2c4.9 16.4 22.1 25.6 38.5 20.7 2.3-.7 4.4-1.6 6.5-2.8 9.7 5.4 21.5 5.4 31.2 0 14.8 8.5 33.7 3.3 42.2-11.5 1.2-2 2.1-4.2 2.8-6.5l18-60.1c1.1-4 1.6-8.2 1.4-12.4-.1-18.3-15.1-33.3-33.6-33.3zm-33.8-36.7 1.8 3.6c-6.3 8.7-10.8 21.4-10 33.4-2.3-.4-8.6-.7-12.4.7.8-15.1 8.4-28.9 20.6-37.7zm-57.9 138.1-18-60.1c-1.7-5.7-.9-12.5 1.9-17 4.6-7.4 15.7-10.2 23.7-5.9 3.8 2 5.3 3.4 6.8 5.3-.7 2.7-1.1 5.5-1.1 8.3v64c0 5.5 1.4 10.9 4.1 15.7-7.7 1.6-15.2-2.9-17.4-10.3zm29.2-5.4v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16zm79.3-54.7-18 60.1c-2.2 7.4-9.8 11.9-17.4 10.3 2.7-4.8 4.1-10.2 4.1-15.7v-64c0-2.5-.3-4.9-.9-7.3 2.1-3.2 6.9-8.7 15.3-8.7 9.7 0 17.5 7.9 17.5 17.5.2 2.6 0 5.3-.6 7.8z' />
            </g>
        </g>
    </svg>
);

const teleDoctorIcon = (
    <svg
        version='1.1'
        className='teleDoctorIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace='preserve'
    >
        <linearGradient
            id='SVGID_1_'
            gradientUnits='userSpaceOnUse'
            x1='437.0193'
            y1='76.9807'
            x2='74.9807'
            y2='439.0193'
            gradientTransform='matrix(1 0 0 -1 0 514)'
        >
            <stop
                offset='0'
                style={{ stopColor: '#008878' }}
            />
            <stop
                offset='1'
                style={{ stopColor: '#00EFD1' }}
            />
        </linearGradient>
        <circle
            style={{ fill: 'url(#SVGID_1_)' }}
            cx='256'
            cy='256'
            r='256'
        />
        <linearGradient
            id='SVGID_2_'
            gradientUnits='userSpaceOnUse'
            x1='69.1387'
            y1='298.1388'
            x2='307.7487'
            y2='59.5187'
            gradientTransform='matrix(1 0 0 -1 0 514)'
        >
            <stop
                offset='0'
                style={{ stopColor: '#CA80DE' }}
            />
            <stop
                offset='1'
                style={{ stopColor: '#5C1B6F' }}
            />
        </linearGradient>
        <path
            style={{ fill: 'url(#SVGID_2_)' }}
            d='M167.027,241.785l-11.713,11.713c-4.746,4.746-4.746,12.468,0,17.214l84.84,84.84
	        c4.746,4.746,12.468,4.746,17.214,0l11.713-11.713l73.439,73.439l-11.713,11.713c-33.226,33.226-87.289,33.226-120.515,0
	        L81.875,300.574c-33.226-33.226-33.226-87.289,0-120.515l11.713-11.713L167.027,241.785z'
        />
        <g>
            <linearGradient
                id='SVGID_3_'
                gradientUnits='userSpaceOnUse'
                x1='116.3182'
                y1='345.3182'
                x2='354.9382'
                y2='106.6982'
                gradientTransform='matrix(1 0 0 -1 0 514)'
            >
                <stop
                    offset='0'
                    style={{ stopColor: '#FFFFFF' }}
                />
                <stop
                    offset='1'
                    style={{ stopColor: '#FFEC98' }}
                />
            </linearGradient>
            <path
                style={{ fill: 'url(#SVGID_3_)' }}
                d='M266.425,342.195l77.049,77.049c2.607,2.607,6.834,2.607,9.441,0l2.481-2.481
		        c8.95-8.95,8.95-23.46,0-32.409l-54.08-54.081c-8.95-8.95-23.46-8.95-32.409,0l-2.481,2.481
		        C263.818,335.362,263.818,339.588,266.425,342.195z'
            />

            <linearGradient
                id='SVGID_4_'
                gradientUnits='userSpaceOnUse'
                x1='116.318'
                y1='345.318'
                x2='354.938'
                y2='106.698'
                gradientTransform='matrix(1 0 0 -1 0 514)'
            >
                <stop
                    offset='0'
                    style={{ stopColor: '#FFFFFF' }}
                />
                <stop
                    offset='1'
                    style={{ stopColor: '#FFEC98' }}
                />
            </linearGradient>
            <path
                style={{ fill: 'url(#SVGID_4_)' }}
                d='M91.724,167.494l77.049,77.049c2.607,2.607,6.834,2.607,9.441,0l2.481-2.481
		        c8.95-8.95,8.95-23.46,0-32.409l-54.081-54.081c-8.95-8.949-23.46-8.949-32.409,0l-2.481,2.481
		        C89.117,160.661,89.117,164.887,91.724,167.494z'
            />
        </g>
        <linearGradient
            id='SVGID_5_'
            gradientUnits='userSpaceOnUse'
            x1='195.9312'
            y1='424.9312'
            x2='434.5512'
            y2='186.3112'
            gradientTransform='matrix(1 0 0 -1 0 514)'
        >
            <stop
                offset='0'
                style={{ stopColor: '#FFFFFF' }}
            />
            <stop
                offset='1'
                style={{ stopColor: '#FFEC98' }}
            />
        </linearGradient>
        <path
            style={{ fill: 'url(#SVGID_5_)' }}
            d='M319.209,76.671c-64.295,0-116.416,52.121-116.416,116.416
	        c0,24.308,7.454,46.873,20.196,65.542l-6.07,35.324l38.423-3.527c18.338,12.056,40.281,19.077,63.867,19.077
	        c64.295,0,116.416-52.121,116.416-116.416C435.625,128.793,383.504,76.671,319.209,76.671z'
        />
        <linearGradient
            id='SVGID_6_'
            gradientUnits='userSpaceOnUse'
            x1='262.769'
            y1='320.912'
            x2='375.649'
            y2='320.912'
            gradientTransform='matrix(1 0 0 -1 0 514)'
        >
            <stop
                offset='0'
                style={{ stopColor: '#FF2F57' }}
            />
            <stop
                offset='1'
                style={{ stopColor: '#9A0011' }}
            />
        </linearGradient>
        <polygon
            style={{ fill: 'url(#SVGID_6_)' }}
            points='375.649,169.795 342.501,169.795 342.501,136.648 295.916,136.648 295.916,169.795 262.769,169.795 262.769,216.38 295.916,216.38 295.916,249.528 342.501,249.528 342.501,216.38 375.649,216.38 '
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
);

const blackCardIcon = (
    <img
        className='blackCardIcon'
        src={blackCardIconSrc}
        alt='Black Card'
    />
);

const approveIcon = (
    <svg
        version='1.1'
        className='approveIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 468.293 468.293'
        style={{ enableBackground: 'new 0 0 468.293 468.293' }}
        xmlSpace='preserve'
    >
        <path
            style={{ fill: '#E1E6E9' }}
            d='M355.658,12.488v401.079H70.378c-6.897,0-12.488-5.591-12.488-12.488V74.662L132.553,0H343.17
	        C350.067,0,355.658,5.591,355.658,12.488z'
        />
        <polygon
            style={{ fill: '#EBF0F3' }}
            points='132.553,0 132.553,74.662 57.89,74.662 '
        />
        <g>
            <rect
                x='168.532'
                y='56.002'
                style={{ fill: '#D5D6DB' }}
                width='156.847'
                height='18.432'
            />
            <rect
                x='143.051'
                y='112.628'
                style={{ fill: '#D5D6DB' }}
                width='182.384'
                height='18.432'
            />
            <rect
                x='143.051'
                y='169.253'
                style={{ fill: '#D5D6DB' }}
                width='182.384'
                height='18.432'
            />
            <rect
                x='143.051'
                y='225.879'
                style={{ fill: '#D5D6DB' }}
                width='182.384'
                height='18.432'
            />
            <rect
                x='143.051'
                y='282.512'
                style={{ fill: '#D5D6DB' }}
                width='182.384'
                height='18.432'
            />
            <rect
                x='143.051'
                y='339.138'
                style={{ fill: '#D5D6DB' }}
                width='182.384'
                height='18.432'
            />
        </g>
        <g>
            <rect
                x='88.142'
                y='112.628'
                style={{ fill: '#64798A' }}
                width='24.969'
                height='18.432'
            />
            <rect
                x='88.142'
                y='169.253'
                style={{ fill: '#64798A' }}
                width='24.969'
                height='18.432'
            />
            <rect
                x='88.142'
                y='225.879'
                style={{ fill: '#64798A' }}
                width='24.969'
                height='18.432'
            />
            <rect
                x='88.142'
                y='282.512'
                style={{ fill: '#64798A' }}
                width='24.969'
                height='18.432'
            />
            <rect
                x='88.142'
                y='339.138'
                style={{ fill: '#64798A' }}
                width='24.969'
                height='18.432'
            />
        </g>
        <circle
            style={{ fill: '#44C4A1' }}
            cx='311.562'
            cy='369.452'
            r='98.841'
        />
        <path
            style={{ fill: '#EBF0F3' }}
            d='M290.76,424.313c-2.915,0-5.772-1.182-7.828-3.246l-30.58-30.575
	        c-2.091-2.091-3.246-4.872-3.246-7.828c0-2.959,1.156-5.74,3.246-7.831c2.091-2.093,4.872-3.246,7.828-3.246
	        s5.737,1.153,7.828,3.246l19.901,19.892c18.229-32.865,41.939-59.848,68.745-78.196c1.852-1.269,4.013-1.937,6.248-1.937
	        c3.658,0,7.079,1.8,9.146,4.82c1.667,2.442,2.288,5.386,1.742,8.293c-0.54,2.909-2.183,5.43-4.628,7.099
	        c-27.398,18.751-51.068,47.552-68.449,83.28c-1.556,3.211-4.593,5.482-8.118,6.074C291.985,424.26,291.369,424.313,290.76,424.313z'
        />
    </svg>
);

const denyIcon = (
    <svg
        className='denyIcon'
        height='512pt'
        viewBox='0 0 512 512'
        width='512pt'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='m208.160156 0h208.160156v512h-208.160156zm0 0'
            fill='#efe2dd'
        />
        <path
            d='m0 0v512h208.160156v-48.785156l-10.007812-15.007813 10.007812-14.996093v-33.785157l-10.007812-14.992187 10.007812-15.003906v-225.144532l10.007813-15-10.007813-15v-33.78125l10.007813-15-10.007813-15v-50.503906zm0 0'
            fill='#fff5f5'
        />
        <path
            d='m47.839844 433.214844h160.320312v30h-160.320312zm0 0'
            fill='#cdbfba'
        />
        <path
            d='m47.839844 369.429688h160.320312v30h-160.320312zm0 0'
            fill='#cdbfba'
        />
        <path
            d='m132.925781 123.929688c9.203125-7.613282 15.082031-19.113282 15.082031-31.964844 0-22.863282-18.605468-41.464844-41.46875-41.464844-22.859374 0-41.464843 18.601562-41.464843 41.46875 0 12.847656 5.878906 24.351562 15.082031 31.960938-19.148438 9.679687-32.316406 29.535156-32.316406 52.414062v24.230469h117.402344v-24.230469c0-22.882812-13.167969-42.734375-32.316407-52.414062zm0 0'
            fill='#cdbfba'
        />
        <g fill='#9b9696'>
            <path d='m208.160156 50.503906h160.320313v30h-160.320313zm0 0' />
            <path d='m208.160156 114.285156h160.320313v30h-160.320313zm0 0' />
            <path d='m368.480469 335.644531v-30h-160.320313l-10.007812 15 10.007812 15zm0 0' />
            <path d='m368.480469 241.859375h-160.320313l-10.007812 15.777344 10.007812 14.222656h160.320313zm0 0' />
        </g>
        <path
            d='m47.839844 305.644531h160.320312v30h-160.320312zm0 0'
            fill='#cdbfba'
        />
        <path
            d='m47.839844 241.859375h160.320312v30h-160.320312zm0 0'
            fill='#cdbfba'
        />
        <path
            d='m390.066406 198.710938-20.015625 121.933593 20.015625 121.933594c67.339844 0 121.933594-54.59375 121.933594-121.933594 0-67.34375-54.59375-121.933593-121.933594-121.933593zm0 0'
            fill='#e30000'
        />
        <path
            d='m268.132812 320.644531c0 67.339844 54.589844 121.933594 121.933594 121.933594v-243.867187c-67.34375 0-121.933594 54.589843-121.933594 121.933593zm0 0'
            fill='#ff4c04'
        />
        <path
            d='m453.066406 278.855469-21.214844-21.210938-41.785156 41.785157-10.007812 21.214843 10.007812 21.210938 41.785156 41.789062 21.214844-21.214843-41.789062-41.785157zm0 0'
            fill='#efe2dd'
        />
        <path
            d='m348.28125 257.644531-21.214844 21.210938 41.789063 41.789062-41.789063 41.785157 21.214844 21.214843 41.785156-41.789062v-42.425781zm0 0'
            fill='#fff5f5'
        />
    </svg>
);

const HistoryIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
    >
        <path d='M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' />
    </svg>
);

const oopIcon = (
    <svg
        version='1.1'
        className='oopIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace='preserve'
    >
        <path
            style={{ fill: '#0E9347' }}
            d='M488.727,325.818H23.273C10.473,325.818,0,315.345,0,302.545v-256
	        c0-12.8,10.473-23.273,23.273-23.273h465.455c12.8,0,23.273,10.473,23.273,23.273v256C512,315.345,501.527,325.818,488.727,325.818z
	        '
        />
        <path
            style={{ fill: '#0D8944' }}
            d='M430.545,232.727c-26.764,0-51.2,12.8-65.164,33.745C353.745,260.655,340.945,256,325.818,256
	        c-40.727,0-74.473,30.255-80.291,69.818h243.2c11.636,0,20.945-8.145,23.273-19.782
	        C507.345,265.309,472.436,232.727,430.545,232.727z'
        />
        <path
            style={{ fill: '#3BB54A' }}
            d='M442.182,302.545H69.818c0-25.6-20.945-46.545-46.545-46.545V93.091
	        c25.6,0,46.545-20.945,46.545-46.545h372.364c0,25.6,20.945,46.545,46.545,46.545V256C463.127,256,442.182,276.945,442.182,302.545z
	        '
        />
        <g>
            <path
                style={{ fill: '#0E9347' }}
                d='M430.545,232.727c-26.764,0-51.2,12.8-65.164,33.745C353.745,260.655,340.945,256,325.818,256
		        c-32.582,0-60.509,18.618-73.309,46.545h189.673c0-25.6,19.782-45.382,45.382-46.545
		        C472.436,242.036,452.655,232.727,430.545,232.727z'
            />
            <ellipse
                style={{ fill: '#0E9347' }}
                cx='256'
                cy='174.545'
                rx='93.091'
                ry='104.727'
            />
            <circle
                style={{ fill: '#0E9347' }}
                cx='116.364'
                cy='174.545'
                r='23.273'
            />
            <circle
                style={{ fill: '#0E9347' }}
                cx='395.636'
                cy='174.545'
                r='23.273'
            />
        </g>
        <path
            style={{ fill: '#89C763' }}
            d='M267.636,162.909h-23.273c-6.982,0-11.636-4.655-11.636-11.636c0-6.982,4.655-11.636,11.636-11.636
	        h34.909c6.982,0,11.636-4.655,11.636-11.636c0-6.982-4.655-11.636-11.636-11.636h-11.636c0-6.982-4.655-11.636-11.636-11.636
	        c-6.982,0-11.636,4.655-11.636,11.636c-19.782,0-34.909,15.127-34.909,34.909s15.127,34.909,34.909,34.909h23.273
	        c6.982,0,11.636,4.655,11.636,11.636c0,6.982-4.655,11.636-11.636,11.636h-34.909c-6.982,0-11.636,4.655-11.636,11.636
	        c0,6.982,4.655,11.636,11.636,11.636h11.636c0,6.982,4.655,11.636,11.636,11.636c6.982,0,11.636-4.655,11.636-11.636
	        c19.782,0,34.909-15.127,34.909-34.909S287.418,162.909,267.636,162.909z'
        />
        <circle
            style={{ fill: '#FFCA5D' }}
            cx='302.545'
            cy='337.455'
            r='81.455'
        />
        <circle
            style={{ fill: '#F6B545' }}
            cx='407.273'
            cy='314.182'
            r='81.455'
        />
        <path
            style={{ fill: '#FFCB5B' }}
            d='M407.273,232.727c-45.382,0-81.455,36.073-81.455,81.455s36.073,81.455,81.455,81.455
	        s81.455-36.073,81.455-81.455S452.655,232.727,407.273,232.727z M407.273,372.364c-32.582,0-58.182-25.6-58.182-58.182
	        S374.691,256,407.273,256s58.182,25.6,58.182,58.182S439.855,372.364,407.273,372.364z'
        />
        <path
            style={{ fill: '#F6B545' }}
            d='M407.273,394.473L407.273,394.473c45.382,1.164,81.455-36.073,81.455-80.291h-1.164
	        c-5.818,0-10.473,4.655-11.636,10.473c-2.327,16.291-10.473,31.418-22.109,41.891c-9.309,9.309-22.109,15.127-36.073,17.454
	        C411.927,384,407.273,388.655,407.273,394.473z'
        />
        <path
            style={{ fill: '#FFE27A' }}
            d='M407.273,233.891L407.273,233.891c-45.382-1.164-81.455,36.073-81.455,80.291h1.164
	        c5.818,0,10.473-4.655,11.636-10.473c2.327-16.291,10.473-31.418,22.109-41.891c9.309-9.309,22.109-15.127,36.073-17.455
	        C402.618,244.364,407.273,239.709,407.273,233.891z'
        />
        <path
            style={{ fill: '#F19920' }}
            d='M357.236,322.327c0-32.582,25.6-58.182,58.182-58.182c13.964,0,26.764,4.655,37.236,13.964
	        C441.018,264.145,425.891,256,407.273,256c-32.582,0-58.182,25.6-58.182,58.182c0,18.618,8.145,33.745,20.945,44.218
	        C361.891,349.091,357.236,336.291,357.236,322.327z'
        />
        <path
            style={{ fill: '#FFCB5B' }}
            d='M442.182,350.255c-1.164,0-2.327,0-3.491-1.164c-2.327-2.327-2.327-5.818,0-8.145
	        c6.982-6.982,10.473-17.455,10.473-26.764c0-3.491,2.327-5.818,5.818-5.818c3.491,0,5.818,2.327,5.818,5.818
	        c0,12.8-4.655,25.6-12.8,34.909C445.673,350.255,443.345,350.255,442.182,350.255z'
        />
        <g>
            <path
                style={{ fill: '#F19920' }}
                d='M407.273,349.091c-6.982,0-11.636-4.655-11.636-11.636v-46.545c0-6.982,4.655-11.636,11.636-11.636
		        s11.636,4.655,11.636,11.636v46.545C418.909,344.436,414.255,349.091,407.273,349.091z'
            />
            <path
                style={{ fill: '#F19920' }}
                d='M450.327,382.836c-8.145-29.091-29.091-52.364-55.855-62.836c-4.655-26.764-22.109-50.036-44.218-64
		        c-13.964,15.127-23.273,34.909-23.273,57.018c0,45.382,36.073,81.455,81.455,81.455
		        C423.564,395.636,437.527,390.982,450.327,382.836z'
            />
        </g>
        <g>
            <path
                style={{ fill: '#E78825' }}
                d='M370.036,358.4c-8.145-10.473-13.964-23.273-13.964-37.236c0-16.291,6.982-31.418,18.618-41.891
		        c-2.327-3.491-4.655-5.818-6.982-8.145c-11.636,10.473-18.618,25.6-18.618,43.055C349.091,332.8,357.236,347.927,370.036,358.4z'
            />
            <path
                style={{ fill: '#E78825' }}
                d='M395.636,321.164v16.291c0,6.982,4.655,11.636,11.636,11.636s11.636-4.655,11.636-11.636v-2.327
		        C411.927,329.309,403.782,324.655,395.636,321.164z'
            />
        </g>
        <path
            style={{ fill: '#F6B545' }}
            d='M450.327,382.836c-2.327-8.145-4.655-15.127-9.309-22.109c-9.309,6.982-20.945,11.636-33.745,11.636
	        c-32.582,0-58.182-25.6-58.182-58.182c0-17.455,6.982-32.582,18.618-43.055c-5.818-5.818-11.636-10.473-18.618-13.964
	        c-13.964,15.127-23.273,34.909-23.273,57.018c0,45.382,36.073,81.455,81.455,81.455
	        C423.564,395.636,437.527,390.982,450.327,382.836z'
        />
        <path
            style={{ fill: '#F19920' }}
            d='M446.836,372.364c-8.145,5.818-18.618,9.309-29.091,11.636c-5.818,1.164-10.473,5.818-10.473,11.636
	        l0,0c16.291,0,30.255-4.655,43.055-12.8C449.164,379.345,448,375.855,446.836,372.364z'
        />
        <path
            style={{ fill: '#FFCB5B' }}
            d='M349.091,257.164c-13.964,15.127-23.273,34.909-23.273,57.018h1.164
	        c5.818,0,10.473-4.655,11.636-10.473c2.327-16.291,10.473-30.255,20.945-40.727C356.073,261.818,352.582,259.491,349.091,257.164z'
        />
        <circle
            style={{ fill: '#F6B545' }}
            cx='302.545'
            cy='337.455'
            r='81.455'
        />
        <path
            style={{ fill: '#F19920' }}
            d='M290.909,395.636c0,8.145,1.164,15.127,3.491,23.273c2.327,0,5.818,0,8.145,0
	        c45.382,0,81.455-36.073,81.455-81.455c0-8.145-1.164-15.127-3.491-23.273c-2.327,0-5.818,0-8.145,0
	        C326.982,314.182,290.909,350.255,290.909,395.636z'
        />
        <path
            style={{ fill: '#FFCB5B' }}
            d='M302.545,256c-45.382,0-81.455,36.073-81.455,81.455s36.073,81.455,81.455,81.455
	        S384,382.836,384,337.455S347.927,256,302.545,256z M302.545,395.636c-32.582,0-58.182-25.6-58.182-58.182
	        s25.6-58.182,58.182-58.182s58.182,25.6,58.182,58.182S335.127,395.636,302.545,395.636z'
        />
        <path
            style={{ fill: '#F6B545' }}
            d='M302.545,417.745L302.545,417.745C347.927,418.909,384,381.673,384,337.455h-1.164
	        c-5.818,0-10.473,4.655-11.636,10.473c-2.327,16.291-10.473,31.418-22.109,41.891c-9.309,9.309-22.109,15.127-36.073,17.455
	        C307.2,407.273,302.545,411.927,302.545,417.745z'
        />
        <path
            style={{ fill: '#FFE27A' }}
            d='M302.545,257.164L302.545,257.164c-45.382-1.164-81.455,36.073-81.455,80.291h1.164
	        c5.818,0,10.473-4.655,11.636-10.473c2.327-16.291,10.473-31.418,22.109-41.891c9.309-9.309,22.109-15.127,36.073-17.455
	        C297.891,267.636,302.545,262.982,302.545,257.164z'
        />
        <path
            style={{ fill: '#F19920' }}
            d='M252.509,345.6c0-32.582,25.6-58.182,58.182-58.182c13.964,0,26.764,4.655,37.236,13.964
	        c-11.636-13.964-26.764-22.109-45.382-22.109c-32.582,0-58.182,25.6-58.182,58.182c0,18.618,8.145,33.745,20.945,44.218
	        C257.164,372.364,252.509,359.564,252.509,345.6z'
        />
        <path
            style={{ fill: '#FFCB5B' }}
            d='M337.455,373.527c-1.164,0-2.327,0-3.491-1.164c-2.327-2.327-2.327-5.818,0-8.145
	        c6.982-6.982,10.473-17.455,10.473-26.764c0-3.491,2.327-5.818,5.818-5.818c3.491,0,5.818,2.327,5.818,5.818
	        c0,12.8-4.655,25.6-12.8,34.909C340.945,373.527,338.618,373.527,337.455,373.527z'
        />
        <path
            style={{ fill: '#F19920' }}
            d='M302.545,372.364c-6.982,0-11.636-4.655-11.636-11.636v-46.545c0-6.982,4.655-11.636,11.636-11.636
	        c6.982,0,11.636,4.655,11.636,11.636v46.545C314.182,367.709,309.527,372.364,302.545,372.364z'
        />
        <g>
            <path
                style={{ fill: '#F6B545' }}
                d='M356.073,315.345c2.327,6.982,4.655,13.964,4.655,22.109c0,32.582-25.6,58.182-58.182,58.182
		        c-3.491,0-8.145,0-11.636-1.164v1.164c0,8.145,1.164,15.127,3.491,23.273c2.327,0,5.818,0,8.145,0
		        c45.382,0,81.455-36.073,81.455-81.455c0-8.145-1.164-15.127-3.491-23.273c-2.327,0-5.818,0-8.145,0
		        C366.545,314.182,361.891,314.182,356.073,315.345z'
            />
            <circle
                style={{ fill: '#F6B545' }}
                cx='360.727'
                cy='407.273'
                r='81.455'
            />
        </g>
        <path
            style={{ fill: '#FFCB5B' }}
            d='M360.727,325.818c-45.382,0-81.455,36.073-81.455,81.455s36.073,81.455,81.455,81.455
	        s81.455-36.073,81.455-81.455S406.109,325.818,360.727,325.818z M360.727,465.455c-32.582,0-58.182-25.6-58.182-58.182
	        s25.6-58.182,58.182-58.182s58.182,25.6,58.182,58.182S393.309,465.455,360.727,465.455z'
        />
        <path
            style={{ fill: '#F6B545' }}
            d='M360.727,487.564L360.727,487.564c45.382,1.164,81.455-36.073,81.455-80.291h-1.164
	        c-5.818,0-10.473,4.655-11.636,10.473c-2.327,16.291-10.473,31.418-22.109,41.891c-9.309,9.309-22.109,15.127-36.073,17.455
	        C365.382,477.091,360.727,481.745,360.727,487.564z'
        />
        <path
            style={{ fill: '#FFE27A' }}
            d='M360.727,326.982L360.727,326.982c-45.382-1.164-81.455,36.073-81.455,80.291h1.164
	        c5.818,0,10.473-4.655,11.636-10.473c2.327-16.291,10.473-31.418,22.109-41.891c9.309-9.309,22.109-15.127,36.073-17.455
	        C356.073,337.455,360.727,332.8,360.727,326.982z'
        />
        <path
            style={{ fill: '#F19920' }}
            d='M310.691,415.418c0-32.582,25.6-58.182,58.182-58.182c13.964,0,26.764,4.655,37.236,13.964
	        c-11.636-13.964-26.764-22.109-45.382-22.109c-32.582,0-58.182,25.6-58.182,58.182c0,18.618,8.145,33.745,20.945,44.218
	        C315.345,442.182,310.691,429.382,310.691,415.418z'
        />
        <path
            style={{ fill: '#FFCB5B' }}
            d='M395.636,443.345c-1.164,0-2.327,0-3.491-1.164c-2.327-2.327-2.327-5.818,0-8.145
	        c6.982-6.982,10.473-17.455,10.473-26.764c0-3.491,2.327-5.818,5.818-5.818s5.818,2.327,5.818,5.818c0,12.8-4.655,25.6-12.8,34.909
	        C399.127,443.345,396.8,443.345,395.636,443.345z'
        />
        <path
            style={{ fill: '#F19920' }}
            d='M360.727,442.182c-6.982,0-11.636-4.655-11.636-11.636V384c0-6.982,4.655-11.636,11.636-11.636
	        c6.982,0,11.636,4.655,11.636,11.636v46.545C372.364,437.527,367.709,442.182,360.727,442.182z'
        />
    </svg>
);

const labIcon = (
    <svg
        version='1.1'
        className='labIcon'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace='preserve'
    >
        <g>
            <g>
                <path
                    style={{ fill: '#AEEFFF' }}
                    d='M438.953,437.585L304,232.828V32h-96v200.828L73.046,437.585
			        C52.012,469.499,74.901,512,113.124,512h285.751C437.098,512,459.988,469.499,438.953,437.585z'
                />
            </g>
            <g>
                <path
                    style={{ fill: '#4CD7FF' }}
                    d='M255.781,32H208v200.828L73.046,437.585C52.012,469.499,74.901,512,113.124,512H255.78V32H255.781z
			        '
                />
            </g>
            <g>
                <path
                    style={{ fill: '#E3001E' }}
                    d='M418.913,450.793l-57.469-87.195c-1.477-2.246-3.992-3.598-6.68-3.598h-197.53
			        c-2.687,0-5.203,1.352-6.68,3.598l-57.469,87.191c-4.953,7.508-5.359,16.703-1.094,24.582C96.234,483.277,104.14,488,113.124,488
			        h285.75c8.984,0,16.891-4.723,21.125-12.609C424.273,467.492,423.867,458.297,418.913,450.793z'
                />
            </g>
            <g>
                <path
                    style={{ fill: '#FF4F19' }}
                    d='M361.445,363.598c-1.477-2.246-3.992-3.598-6.68-3.598h-98.984v128h143.094
			        c8.984,0,16.891-4.723,21.125-12.609c4.273-7.898,3.867-17.094-1.086-24.598L361.445,363.598z'
                />
            </g>
            <g>
                <path
                    style={{ fill: '#4BB9EC' }}
                    d='M304,32h-96c-8.837,0-16-7.163-16-16l0,0c0-8.837,7.163-16,16-16h96c8.837,0,16,7.163,16,16l0,0
			        C320,24.837,312.836,32,304,32z'
                />
            </g>
            <g>
                <circle
                    style={{ fill: '#FF4F19' }}
                    cx='200'
                    cy='416'
                    r='16'
                />
            </g>
            <g>
                <circle
                    style={{ fill: '#E3001E' }}
                    cx='328'
                    cy='432'
                    r='16'
                />
            </g>
            <g>
                <g>
                    <path
                        style={{ fill: '#E3001E' }}
                        d='M280.023,416c-2.164,0-4.164-0.883-5.688-2.32c-1.516-1.52-2.313-3.602-2.313-5.68
				        c0-2.082,0.797-4.16,2.313-5.68c2.961-2.961,8.32-2.961,11.281,0c1.523,1.52,2.406,3.52,2.406,5.68s-0.883,4.16-2.406,5.68
				        C284.179,415.117,282.101,416,280.023,416z'
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        style={{ fill: '#AEEFFF' }}
                        d='M231.781,328c-2.164,0-4.164-0.883-5.688-2.32c-1.516-1.52-2.313-3.602-2.313-5.68
				        c0-2.082,0.797-4.16,2.313-5.68c2.961-2.961,8.242-2.961,11.281,0c1.523,1.52,2.406,3.598,2.406,5.68
				        c0,2.078-0.883,4.16-2.32,5.68C235.937,327.117,233.859,328,231.781,328z'
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        style={{ fill: '#4CD7FF' }}
                        d='M279.781,264c-2.164,0-4.164-0.883-5.688-2.32c-1.516-1.52-2.313-3.602-2.313-5.68
				        c0-2.082,0.797-4.16,2.313-5.68c2.961-2.961,8.242-2.961,11.281,0c1.523,1.52,2.406,3.598,2.406,5.68
				        c0,2.078-0.883,4.16-2.406,5.68C283.937,263.117,281.859,264,279.781,264z'
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        style={{ fill: '#AEEFFF' }}
                        d='M231.781,208c-2.164,0-4.242-0.883-5.688-2.402c-1.516-1.438-2.313-3.52-2.313-5.598
				        c0-2.082,0.797-4.16,2.313-5.68c2.961-2.961,8.32-2.961,11.281,0c1.523,1.52,2.406,3.598,2.406,5.68
				        c0,2.078-0.883,4.16-2.406,5.68C235.937,207.117,233.859,208,231.781,208z'
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        style={{ fill: '#FF4F19' }}
                        d='M231.781,463.9c-2.164,0-4.164-0.883-5.688-2.32c-1.516-1.52-2.313-3.602-2.313-5.68
				        c0-2.082,0.797-4.16,2.313-5.68c2.961-2.961,8.32-2.961,11.281,0c1.523,1.52,2.406,3.598,2.406,5.68
				        c0,2.078-0.883,4.16-2.406,5.68C235.937,463.017,233.859,463.9,231.781,463.9z'
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        style={{ fill: '#FF4F19' }}
                        d='M152.023,456c-2.164,0-4.242-0.883-5.688-2.32c-1.516-1.52-2.313-3.602-2.313-5.68
				        c0-2.082,0.797-4.16,2.313-5.68c2.961-2.961,8.32-2.961,11.281,0c1.523,1.52,2.406,3.598,2.406,5.68
				        c0,2.078-0.883,4.16-2.406,5.68C156.179,455.117,154.101,456,152.023,456z'
                    />
                </g>
            </g>
        </g>
    </svg>
);

const LightBulbIcon = () => (
    <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 432.4 432.4'
        style={{ enableBackground: 'new 0 0 432.4 432.4' }}
        width='100%'
    >
        <g>
            <g>
                <g>
                    <path
                        style={{ fill: '#231F20' }}
                        d='M216.529,93.2c-61.2,0-111.2,50-111.2,111.2c0,32,14,62.8,37.6,83.6c17.6,17.6,16,55.2,15.6,55.6
				c0,2,0.4,3.6,2,5.2c1.2,1.2,3.2,2,4.8,2h102c2,0,3.6-0.8,4.8-2c1.2-1.2,2-3.2,2-5.2c0-0.4-2-38,15.6-55.6
				c0.4-0.4,0.8-0.8,1.2-1.2c23.2-21.2,36.8-51.2,36.8-82.4C327.729,143.2,277.729,93.2,216.529,93.2z M280.529,277.6
				c-0.4,0.4-1.2,1.2-1.2,1.6c-15.6,16.8-18.4,44.4-18.8,57.6h-88.4c-0.4-13.2-3.2-42-20-59.2c-21.2-18.4-33.6-45.2-33.6-73.6
				c0-54,43.6-97.6,97.6-97.6s97.6,43.6,97.6,97.6C313.729,232.4,301.729,259.2,280.529,277.6z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M216.129,121.6c-3.6,0-6.8,3.2-6.8,6.8c0,3.6,3.2,6.8,6.8,6.8c40.4,0,72.8,32.8,72.8,72.8
				c0,3.6,3.2,6.8,6.8,6.8c3.6,0,6.8-3.2,6.8-6.8C302.929,160.4,264.129,121.6,216.129,121.6z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M260.529,358.4h-88.8c-9.2,0-16.8,7.6-16.8,16.8s7.6,16.8,16.8,16.8h88.4
				c9.6-0.4,17.2-7.6,17.2-16.8C277.329,366,269.729,358.4,260.529,358.4z M260.529,378h-88.8c-1.6,0-3.2-1.2-3.2-3.2
				s1.2-3.2,3.2-3.2h88.4c1.6,0,3.2,1.2,3.2,3.2S262.129,378,260.529,378z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M247.329,398.8h-62.4c-9.2,0-16.8,7.6-16.8,16.8s7.6,16.8,16.8,16.8h62.4
				c9.2,0,16.8-7.6,16.8-16.8C264.129,406,256.529,398.8,247.329,398.8z M247.329,418.4h-62.4c-1.6,0-3.2-1.2-3.2-3.2
				s1.2-3.2,3.2-3.2h62.4c1.6,0,3.2,1.2,3.2,3.2S248.929,418.4,247.329,418.4z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M216.129,60c4,0,6.8-3.2,6.8-6.8V6.8c0-3.6-3.2-6.8-6.8-6.8c-3.6,0-6.8,3.2-6.8,6.8v46.4
				C209.329,56.8,212.529,60,216.129,60z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M329.329,34.4c-3.2-2.4-7.2-1.2-9.2,1.6l-25.6,38.4c-2.4,3.2-1.6,7.6,1.6,9.6
				c1.2,0.8,2.4,1.2,3.6,1.2c2.4,0,4.4-1.2,5.6-3.2l25.6-38.4C333.329,40.8,332.529,36.4,329.329,34.4z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M134.929,83.6c1.2,0,2.4-0.4,3.6-1.2c3.2-2,4-6.4,2-9.6l-24.8-38.8c-2-3.2-6.4-4-9.6-2
				s-4,6.4-2,9.6l24.8,38.8C130.529,82.8,132.529,83.6,134.929,83.6z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M86.529,126l-40.4-22c-3.2-1.6-7.6-0.4-9.2,2.8c-2,3.2-0.8,7.6,2.8,9.2l40.4,22
				c1.2,0.4,2,0.8,3.2,0.8c2.4,0,4.8-1.2,6-3.6C90.929,132,89.729,127.6,86.529,126z'
                    />
                    <path
                        style={{ fill: '#231F20' }}
                        d='M395.729,106.8c-1.6-3.2-6-4.4-9.2-2.8l-40.8,22c-3.2,1.6-4.4,6-2.8,9.2c1.2,2.4,3.6,3.6,6,3.6
				c1.2,0,2.4-0.4,3.2-0.8l40.8-22C396.129,114.4,397.329,110,395.729,106.8z'
                    />
                </g>
            </g>
        </g>
    </svg>
);

const NotesIcon = () => (
    <svg
        version='1.1'
        id='Capa_1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
    >
        <g>
            <g>
                <path
                    d='M38.45,0v512h261.268L473.55,338.168V0H38.45z M308.505,460.787V346.959h113.828L308.505,460.787z M443.55,316.959
			H278.505V482H68.45V30h375.1V316.959z'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='136.49'
                    y='142.87'
                    width='239.03'
                    height='30'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='136.49'
                    y='230.52'
                    width='239.03'
                    height='30'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='136.81'
                    y='316.96'
                    width='112.68'
                    height='30'
                />
            </g>
        </g>
    </svg>
);

const PencilIcon = () => (
    <svg
        viewBox='-15 -15 484.00019 484'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m401.648438 18.234375c-24.394532-24.351563-63.898438-24.351563-88.292969 0l-22.101563 22.222656-235.269531 235.144531-.5.503907c-.121094.121093-.121094.25-.25.25-.25.375-.625.746093-.871094 1.121093 0 .125-.128906.125-.128906.25-.25.375-.371094.625-.625 1-.121094.125-.121094.246094-.246094.375-.125.375-.25.625-.378906 1 0 .121094-.121094.121094-.121094.25l-52.199219 156.96875c-1.53125 4.46875-.367187 9.417969 2.996094 12.734376 2.363282 2.332031 5.550782 3.636718 8.867188 3.625 1.355468-.023438 2.699218-.234376 3.996094-.625l156.847656-52.324219c.121094 0 .121094 0 .25-.121094.394531-.117187.773437-.285156 1.121094-.503906.097656-.011719.183593-.054688.253906-.121094.371094-.25.871094-.503906 1.246094-.753906.371093-.246094.75-.621094 1.125-.871094.125-.128906.246093-.128906.246093-.25.128907-.125.378907-.246094.503907-.5l257.371093-257.371094c24.351563-24.394531 24.351563-63.898437 0-88.289062zm-232.273438 353.148437-86.914062-86.910156 217.535156-217.535156 86.914062 86.910156zm-99.15625-63.808593 75.929688 75.925781-114.015626 37.960938zm347.664062-184.820313-13.238281 13.363282-86.917969-86.917969 13.367188-13.359375c14.621094-14.609375 38.320312-14.609375 52.945312 0l33.964844 33.964844c14.511719 14.6875 14.457032 38.332031-.121094 52.949218zm0 0' />
    </svg>
);

const OpenLockIcon = () => (
    <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
    >
        <path
            d='M222.5,175v-72.5C222.5,45.981,176.519,0,120,0S17.5,45.981,17.5,102.5V190h30v-87.5C47.5,62.523,80.023,30,120,30
	s72.5,32.523,72.5,72.5V175h-70v310h345V175H222.5z M437.5,455h-285V205h285V455z'
        />
    </svg>
);

const LockCheckIcon = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 485 485'
        style={{ enableBackground: 'new 0 0 485 485' }}
    >
        <g>
            <polygon points='307.299,307.286 286.086,286.073 230.052,342.107 192.457,304.513 171.244,325.726 230.052,384.534 	' />
            <path
                d='M345,175v-72.5C345,45.981,299.019,0,242.5,0S140,45.981,140,102.5V175H70v310h345V175H345z M170,102.5
		c0-39.977,32.523-72.5,72.5-72.5S315,62.523,315,102.5V175H170V102.5z M385,455H100V205h285V455z'
            />
        </g>
    </svg>
);

const ThinCircleXIcon = () => (
    <svg
        viewBox='0 0 1030 1030'
        style={{ maxWidth: '1.6em', height: 'auto' }}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            id='path'
            style={{
                opacity: 1,
                fill: 'rgb(22, 117, 169)',
                fillOpacity: 1,
                strokeMiterlimit: 15,
                stroke: 'rgb(22, 117, 169)',
                strokeWidth: '30px',
            }}
            d='M 515 16 C 239 16 15 240 15 516 C 15 792 239 1016 515 1016 C 791 1016 1015 792 1015 516 C 1015 240 791 16 515 16 C 515 16 515 16 515 16 M 515 41 C 777 41 990 254 990 516 C 990 778 777 991 515 991 C 253 991 40 778 40 516 C 40 254 253 41 515 41 C 515 41 515 41 515 41 M 315 303 C 318 303 321 305 324 307 C 324 307 515 498 515 498 C 515 498 706 307 706 307 C 708 305 712 303 715 303 C 720 303 725 306 727 311 C 729 316 728 321 724 325 C 724 325 533 516 533 516 C 533 516 724 707 724 707 C 727 710 728 715 727 719 C 726 724 723 727 718 728 C 714 729 709 728 706 725 C 706 725 515 534 515 534 C 515 534 324 725 324 725 C 321 728 316 729 312 728 C 307 727 304 724 303 719 C 302 715 303 710 306 707 C 306 707 497 516 497 516 C 497 516 306 325 306 325 C 303 321 301 316 303 311 C 305 306 310 303 315 303 C 315 303 315 303 315 303'
        />
    </svg>
);

const LockXIcon = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 485 485'
        style={{ enableBackground: 'new 0 0 485 485' }}
    >
        <g>
            <polygon points='209.537,384.175 242.5,351.213 275.463,384.175 296.676,362.962 263.713,330 296.676,297.038 275.463,275.825 242.5,308.787 209.537,275.825 188.324,297.038 221.287,330 188.324,362.962 	' />
            <path
                d='M345,175v-72.5C345,45.981,299.019,0,242.5,0S140,45.981,140,102.5V175H70v310h345V175H345z M170,102.5
		c0-39.977,32.523-72.5,72.5-72.5S315,62.523,315,102.5V175H170V102.5z M385,455H100V205h285V455z'
            />
        </g>
    </svg>
);

const ListIcon = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 512 512'
        style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace='preserve'
    >
        <g>
            <g>
                <path
                    d='M112,0H16C7.168,0,0,7.168,0,16v96c0,8.832,7.168,16,16,16h96c8.832,0,16-7.168,16-16V16C128,7.168,120.832,0,112,0z
			         M96,96H32V32h64V96z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M112,192H16c-8.832,0-16,7.168-16,16v96c0,8.832,7.168,16,16,16h96c8.832,0,16-7.168,16-16v-96
			        C128,199.168,120.832,192,112,192z M96,288H32v-64h64V288z'
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d='M112,384H16c-8.832,0-16,7.168-16,16v96c0,8.832,7.168,16,16,16h96c8.832,0,16-7.168,16-16v-96
			        C128,391.168,120.832,384,112,384z M96,480H32v-64h64V480z'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='192'
                    y='16'
                    width='320'
                    height='32'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='192'
                    y='80'
                    width='320'
                    height='32'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='192'
                    y='208'
                    width='320'
                    height='32'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='192'
                    y='272'
                    width='320'
                    height='32'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='192'
                    y='400'
                    width='320'
                    height='32'
                />
            </g>
        </g>
        <g>
            <g>
                <rect
                    x='192'
                    y='464'
                    width='320'
                    height='32'
                />
            </g>
        </g>
    </svg>
);

const CareManagementOutreachIcon = () => (
    <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        width='250px'
        height='250px'
        viewBox='0 0 250 250'
        enableBackground='new 0 0 250 250'
        space='preserve'
    >
        <image
            id='image0'
            width='250'
            height='250'
            x='0'
            y='0'
            href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6CAYAAACI7Fo9AAAABGdBTUEAALGPC/xhBQAAACBjSFJN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'
        />
    </svg>
);

const CheckIcon = (props) => <Check className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />;
const SendIcon = (props) =>
    props.blue ? (
        <Send className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    ) : (
        <SendWhite className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    );
const ReplyIcon = (props) => <Reply className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />;
const TrashIcon = (props) =>
    props.blue ? (
        <Trash className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    ) : (
        <TrashWhite className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    );
const InboxIcon = (props) =>
    props.blue ? (
        <InboxBlue className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    ) : (
        <Inbox className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    );
const NewEmailIcon = (props) => (
    <NewEmail className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
);
const AttachIcon = (props) => (
    <Attachment className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
);
const CancelIcon = (props) => <Cancel className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />;
const ReceptionIcon = (props) => (
    <Reception className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
);
const EditIcon = (props) => <Edit className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />;
const WarningIcon = (props) => <Warning className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />;

const AddIcon = (props) => <Add className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />;
const UploadIcon = (props) => <Upload className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />;
const CopyIcon = (props) =>
    props.white ? (
        <CopyWhite className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    ) : (
        <Copy className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
    );
const CancelWhiteIcon = (props) => (
    <CancelWhite className={`svg-inline--fa fa-w-16 ${props.size ? `fa-${props.size}` : ''}`} />
);

const AppealsAndGrievancesTealIcon = () => (
    <AppealsAndGrievancesTeal
        width='256'
        height={'256'}
    />
);

const AppealsAndGrievancesWhiteIcon = () => (
    <AppealsAndGrievancesWhite
        width='256'
        height={'256'}
    />
);

const InternalEscalation = () => (
    <InternalEscalationIcon className='h-100' style={{ transform: 'scale(1.3)' }}/>
);

const AvaCharts = () => (
    <svg
        viewBox='0 -30 512 512'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m271 240.988281h-30v30.035157h-30.035156v30h30.035156v30.035156h30v-30.035156h30.035156v-30h-30.035156zm0 0' />
        <path d='m256 180.988281c-57.917969 0-105.035156 47.117188-105.035156 105.035157 0 57.917968 47.117187 105.035156 105.035156 105.035156s105.035156-47.117188 105.035156-105.035156c0-57.917969-47.117187-105.035157-105.035156-105.035157zm0 180.070313c-41.375 0-75.035156-33.660156-75.035156-75.035156s33.660156-75.035157 75.035156-75.035157 75.035156 33.660157 75.035156 75.035157-33.660156 75.035156-75.035156 75.035156zm0 0' />
        <path d='m30.023438 0v60.046875h-30.023438v391.902344h512v-451.949219zm-.023438 421.953125v-331.90625h150.953125v60.050781h301.046875v271.851563h-452zm452-301.855469h-271.046875v-30.050781h271.046875zm-421.976562-60.050781v-30.046875h421.976562v30.046875zm0 0' />
    </svg>
);

const icons = {
    FormBuilder: <FormBuilderIcon />,
    MemberPortalAdmin: <MemberPortalAdminIcon />,
    Member: <MemberIcon />,
    ReportsSubmission: <ReportsSubmissionIcon />,
    ProviderData: <ProviderDataIcon />,
    CareManagement: <CareManagementIcon />,
    Encounters: <EncountersIcon />,
    BrokerPortal: <BrokerPortalIcon />,
    Admin: <AdminIcon />,
    Scheduler: <AVASchedulerIcon />,
    Messages: <MessagesIcon />,
    AvaCharts: <AvaCharts />,
    AppealsAndGrievancesTeal: <AppealsAndGrievancesTealIcon />,
    AppealsAndGrievancesWhite: <AppealsAndGrievancesWhiteIcon />,
    AG360: <AppealsAndGrievancesIcon />,
    SearchPatient: <SearchPatientIcon />,
    ListPatient: <ListPatientsIcon />,
    Dashboard: <DashboardIcon />,
    Hospital: <HospitalIcon />,
    History: <AuditHistoryIcon />,
    Census: <FirstAidIcon />,
    JSA: <JSAIcon />,
    UM: <UMIcon />,
    Headphone: <HeadphoneIcon />,
    Coder360: <Coder360Icon />,
    Notes: <NotesIcon />,
    Pencil: <PencilIcon />,
    OpenLock: <OpenLockIcon />,
    LockCheck: <LockCheckIcon />,
    LockX: <LockXIcon />,
    ThinCircleXIcon: <ThinCircleXIcon />,
    List: <ListIcon />,
    ClaimsAuditor: <ClaimsAuditorIcon />,
    PanelManagement: <PanelManagementIcon />,
    VirtualPCP: <VirtualPCP />,
    CareOnDemand: <CareOnDemandIcon />,
    Eligibility: <EligibilityIcon />,
    Authorizations: <AuthorizationsIcon />,
    Check: <CheckIcon />,
    CareManagementOutreach: <CareManagementOutreachIcon />,
    Trash: <TrashIcon />,
    Inbox: <InboxIcon />,
    NewEmailIcon: <NewEmailIcon />,
    ReplyIcon: <ReplyIcon />,
    SendIcon: <SendIcon />,
    AttachIcon: <AttachIcon />,
    CancelIcon: <CancelIcon />,
    ReceptionIcon: <Reception />,
    AddIcon: <AddIcon />,
    UploadIcon: <UploadIcon />,
    CopyIcon: <CopyIcon />,
    CancelWhiteIcon: <CancelWhiteIcon />,
    Claims: <ClaimsInquiryIcon />,
    UtilizationManagement: <UtilizationManagementIcon />,
    PatientPriority: <PatientPriorityIcon />,
    SupplementalReview: <SupplementalReviewIcon />,
    InternalEscalation: <InternalEscalation />,
    'fa-address-book': <FontAwesomeIcon icon={fortAwesome.faAddressBook} />,
    'fa-list-ul': <FontAwesomeIcon icon={fortAwesome.faListUl} />,
    'fa-dashboard': <FontAwesomeIcon icon={fortAwesome.faTachometerAlt} />,
    'fa-comment': <FontAwesomeIcon icon={fortAwesome.faComment} />,
    'fa-comment-alt': <FontAwesomeIcon icon={fortAwesome.faCommentAlt} />,
    'fa-gavel': <FontAwesomeIcon icon={fortAwesome.faGavel} />,
    'fa-paperPlane': <FontAwesomeIcon icon={fortAwesome.faPaperPlane} />,
    'fa-cog': <FontAwesomeIcon icon={fortAwesome.faCog} />,
    'fa-search': <FontAwesomeIcon icon={fortAwesome.faSearch} />,
    'fa-sticky-note': <FontAwesomeIcon icon={fortAwesome.faStickyNote} />,
};

function IconSelector(key) {
    return icons[key] || '';
}

export {
    AppealsAndGrievancesTealIcon,
    AppealsAndGrievancesWhiteIcon,
    AppealsAndGrievancesIcon,
    ReplyIcon,
    CancelIcon,
    EditIcon,
    AttachIcon,
    SendIcon,
    CheckIcon,
    TrashIcon,
    ReceptionIcon,
    InboxIcon,
    NewEmailIcon,
    IconSelector,
    ListPatientsIcon,
    SearchPatientIcon,
    DashboardIcon,
    CareManagementOutreachIcon,
    HospitalIcon,
    HistoryIcon,
    FirstAidIcon,
    JSAIcon,
    UMIcon,
    WarningIcon,
    jsaEditBtnIcon,
    jsaPdfBtnIcon,
    jsaDeleteBtnIcon,
    jsaAppointmentDetailsIcon,
    enrollmentIcon,
    emergencyIcon,
    psychIcon,
    outpatientIcon,
    inpatientIcon,
    medicationIcon,
    procedureIcon,
    inboundIcon,
    outboundIcon,
    callIcon,
    gymIcon,
    transportationIcon,
    dentalIcon,
    visionIcon,
    mealIcon,
    teleDoctorIcon,
    approveIcon,
    denyIcon,
    oopIcon,
    labIcon,
    blackCardIcon,
    HeadphoneIcon,
    LightBulbIcon,
    NotesIcon,
    PencilIcon,
    OpenLockIcon,
    LockCheckIcon,
    LockXIcon,
    ThinCircleXIcon,
    Coder360Icon,
    AddIcon,
    UploadIcon,
    CopyIcon,
    CancelWhiteIcon,
};
